import * as runtime from "@prisma/client/runtime/index-browser";
export const Decimal = runtime.Decimal;
export const NullTypes = {
    DbNull: runtime.NullTypes.DbNull,
    JsonNull: runtime.NullTypes.JsonNull,
    AnyNull: runtime.NullTypes.AnyNull,
};
export const DbNull = runtime.DbNull;
export const JsonNull = runtime.JsonNull;
export const AnyNull = runtime.AnyNull;
export const ModelName = {
    AccountBalanceRecalculation: 'AccountBalanceRecalculation',
    AccountMergeDecision: 'AccountMergeDecision',
    AccountTransfer: 'AccountTransfer',
    AccountTransferSuggestion: 'AccountTransferSuggestion',
    AccountTransferEvent: 'AccountTransferEvent',
    AcubeF24Form: 'AcubeF24Form',
    AcubeJobLog: 'AcubeJobLog',
    AcubePayment: 'AcubePayment',
    SepaPaymentAdminEvent: 'SepaPaymentAdminEvent',
    AdminNotification: 'AdminNotification',
    AdminNotificationTenant: 'AdminNotificationTenant',
    AdvisorProfile: 'AdvisorProfile',
    AdvisorAccessLog: 'AdvisorAccessLog',
    AdvisorTenantSnapshot: 'AdvisorTenantSnapshot',
    AITokenUsage: 'AITokenUsage',
    AITokenUsageMonthly: 'AITokenUsageMonthly',
    AIQuota: 'AIQuota',
    AISystemTokenUsage: 'AISystemTokenUsage',
    AISystemTokenUsageMonthly: 'AISystemTokenUsageMonthly',
    AISystemQuota: 'AISystemQuota',
    AIUsageReservation: 'AIUsageReservation',
    AIProviderReconciliation: 'AIProviderReconciliation',
    AIQueryHistory: 'AIQueryHistory',
    BankImportEnrichmentJob: 'BankImportEnrichmentJob',
    BankSyncCheckpoint: 'BankSyncCheckpoint',
    BankSyncTransaction: 'BankSyncTransaction',
    Account: 'Account',
    CashMovement: 'CashMovement',
    CashMovementAllocation: 'CashMovementAllocation',
    CashMovementSplit: 'CashMovementSplit',
    CashMovementEmbedding: 'CashMovementEmbedding',
    ImportTemplate: 'ImportTemplate',
    ImportHistory: 'ImportHistory',
    AccountBalance: 'AccountBalance',
    InternalTransfer: 'InternalTransfer',
    InternalTransferLink: 'InternalTransferLink',
    InternalTransferSuggestion: 'InternalTransferSuggestion',
    LearnedTransferPattern: 'LearnedTransferPattern',
    InvoiceAdvanceOperation: 'InvoiceAdvanceOperation',
    Carrier: 'Carrier',
    Category: 'Category',
    CategoryKeyword: 'CategoryKeyword',
    CategoryFeedback: 'CategoryFeedback',
    CollectionAccount: 'CollectionAccount',
    Commessa: 'Commessa',
    CommessaAttachment: 'CommessaAttachment',
    CommessaDocumentAllocation: 'CommessaDocumentAllocation',
    CommessaCodeCounter: 'CommessaCodeCounter',
    Company: 'Company',
    CompanyBankAccount: 'CompanyBankAccount',
    CompanyPaReference: 'CompanyPaReference',
    ConsentLog: 'ConsentLog',
    Contract: 'Contract',
    TenantCommercialEntitlement: 'TenantCommercialEntitlement',
    TenantCommercialUsageCounter: 'TenantCommercialUsageCounter',
    CommercialCapacityRequest: 'CommercialCapacityRequest',
    ContractEvent: 'ContractEvent',
    CommercialUsageWarningView: 'CommercialUsageWarningView',
    CommercialUsageWarningClaim: 'CommercialUsageWarningClaim',
    CommercialUsageAlert: 'CommercialUsageAlert',
    CounterpartMaterial: 'CounterpartMaterial',
    CounterpartMaterialReturn: 'CounterpartMaterialReturn',
    CustomerMachine: 'CustomerMachine',
    MachineAssignment: 'MachineAssignment',
    MachineCoverage: 'MachineCoverage',
    WorkReportMachine: 'WorkReportMachine',
    MachineChecklist: 'MachineChecklist',
    MachineCheckPlan: 'MachineCheckPlan',
    MachineCheck: 'MachineCheck',
    MachineFinding: 'MachineFinding',
    MachineAttachment: 'MachineAttachment',
    MachineEvent: 'MachineEvent',
    Debt: 'Debt',
    DebtPaymentSchedule: 'DebtPaymentSchedule',
    DscrSnapshot: 'DscrSnapshot',
    DocumentAdvanceApplication: 'DocumentAdvanceApplication',
    DocumentAdvancePlanEvent: 'DocumentAdvancePlanEvent',
    DocumentAdvanceDeductionLine: 'DocumentAdvanceDeductionLine',
    DocumentElectronicEvent: 'DocumentElectronicEvent',
    DocumentSdiNotification: 'DocumentSdiNotification',
    Document: 'Document',
    DocumentReadReceipt: 'DocumentReadReceipt',
    DocumentPaymentSchedule: 'DocumentPaymentSchedule',
    DistintaRiba: 'DistintaRiba',
    DistintaMovementLink: 'DistintaMovementLink',
    DistintaRibaEvent: 'DistintaRibaEvent',
    RibaMirrorLink: 'RibaMirrorLink',
    DocumentElectronicFile: 'DocumentElectronicFile',
    DocumentLine: 'DocumentLine',
    DocumentVatSummary: 'DocumentVatSummary',
    DocumentWithholding: 'DocumentWithholding',
    DocumentSocialSecurity: 'DocumentSocialSecurity',
    DocumentReference: 'DocumentReference',
    DocumentAttachment: 'DocumentAttachment',
    DocumentEmbedding: 'DocumentEmbedding',
    DocumentPaymentScheduleEmbedding: 'DocumentPaymentScheduleEmbedding',
    DocumentCompensation: 'DocumentCompensation',
    ErrorLogAlertSettings: 'ErrorLogAlertSettings',
    ErrorLog: 'ErrorLog',
    ErrorCategory: 'ErrorCategory',
    ExchangeRate: 'ExchangeRate',
    F24Delegation: 'F24Delegation',
    FiscalInvoiceRecovery: 'FiscalInvoiceRecovery',
    ForecastScenario: 'ForecastScenario',
    ForecastSeries: 'ForecastSeries',
    ForecastOccurrence: 'ForecastOccurrence',
    ForecastPaymentSchedule: 'ForecastPaymentSchedule',
    ReconciliationLink: 'ReconciliationLink',
    ForecastAccountHistoryEvent: 'ForecastAccountHistoryEvent',
    ForeignInvoiceAnalysis: 'ForeignInvoiceAnalysis',
    ForeignInvoiceSourceDocument: 'ForeignInvoiceSourceDocument',
    ForeignInvoiceMovementMatch: 'ForeignInvoiceMovementMatch',
    ForeignInvoiceVendorAlias: 'ForeignInvoiceVendorAlias',
    HotelReservation: 'HotelReservation',
    InfrastructureContract: 'InfrastructureContract',
    InfrastructureCostItem: 'InfrastructureCostItem',
    ProfitabilitySettings: 'ProfitabilitySettings',
    IntegrationConnection: 'IntegrationConnection',
    IntegrationWebhookEvent: 'IntegrationWebhookEvent',
    ExternalDocumentLink: 'ExternalDocumentLink',
    ErpSyncDivergence: 'ErpSyncDivergence',
    ErpSyncRun: 'ErpSyncRun',
    ErpAccountMapping: 'ErpAccountMapping',
    SupplierCatalogItem: 'SupplierCatalogItem',
    IntentDeclaration: 'IntentDeclaration',
    InvoicingSdiTransition: 'InvoicingSdiTransition',
    KnowledgeSource: 'KnowledgeSource',
    KnowledgeDocument: 'KnowledgeDocument',
    KnowledgeChunk: 'KnowledgeChunk',
    KnowledgeDocumentEmbedding: 'KnowledgeDocumentEmbedding',
    KnowledgeChunkEmbedding: 'KnowledgeChunkEmbedding',
    KnowledgeIngestionRun: 'KnowledgeIngestionRun',
    McpAuditLog: 'McpAuditLog',
    McpClient: 'McpClient',
    McpAuthorizationCode: 'McpAuthorizationCode',
    McpToken: 'McpToken',
    MovementSuggestionIndex: 'MovementSuggestionIndex',
    Notification: 'Notification',
    NumberingSequence: 'NumberingSequence',
    PaymentDueReminderDelivery: 'PaymentDueReminderDelivery',
    PaymentTerm: 'PaymentTerm',
    PaymentScheduleTemplate: 'PaymentScheduleTemplate',
    VatRate: 'VatRate',
    StripeTransactions: 'StripeTransactions',
    AccountGroup: 'AccountGroup',
    PaypalFunding: 'PaypalFunding',
    PaypalFundingEvent: 'PaypalFundingEvent',
    PaypalFundingImportReview: 'PaypalFundingImportReview',
    PersonnelCostPeriod: 'PersonnelCostPeriod',
    PersonnelCostAllocation: 'PersonnelCostAllocation',
    PersonnelCostDocument: 'PersonnelCostDocument',
    PersonnelCostEvent: 'PersonnelCostEvent',
    Plan: 'Plan',
    PriceList: 'PriceList',
    PriceListItem: 'PriceListItem',
    PriceListTier: 'PriceListTier',
    PriceListRule: 'PriceListRule',
    ProductRelease: 'ProductRelease',
    ProductReleaseContributor: 'ProductReleaseContributor',
    ProductChange: 'ProductChange',
    Product: 'Product',
    PublicApiKey: 'PublicApiKey',
    PublicApiPaymentExecution: 'PublicApiPaymentExecution',
    PublicApiExternalReference: 'PublicApiExternalReference',
    PublicApiJob: 'PublicApiJob',
    PublicApiIdempotencyKey: 'PublicApiIdempotencyKey',
    PublicApiAuditLog: 'PublicApiAuditLog',
    PublicApiEvent: 'PublicApiEvent',
    PublicApiScanCheckpoint: 'PublicApiScanCheckpoint',
    PublicApiWebhook: 'PublicApiWebhook',
    PublicApiWebhookDelivery: 'PublicApiWebhookDelivery',
    RecurringInvoiceTemplate: 'RecurringInvoiceTemplate',
    Referrer: 'Referrer',
    ReferrerInvitation: 'ReferrerInvitation',
    TenantReferral: 'TenantReferral',
    Commission: 'Commission',
    TenantActivationCharge: 'TenantActivationCharge',
    CommissionReceiptRecognition: 'CommissionReceiptRecognition',
    Country: 'Country',
    Province: 'Province',
    Municipality: 'Municipality',
    MunicipalityValidity: 'MunicipalityValidity',
    MunicipalityTransition: 'MunicipalityTransition',
    SyncRun: 'SyncRun',
    ServiceUsageMonthly: 'ServiceUsageMonthly',
    SepaPayment: 'SepaPayment',
    ServiceContract: 'ServiceContract',
    ServiceContractPeriod: 'ServiceContractPeriod',
    ServiceContractLine: 'ServiceContractLine',
    ServiceContractChange: 'ServiceContractChange',
    BillableCharge: 'BillableCharge',
    ServiceContractEvent: 'ServiceContractEvent',
    Warehouse: 'Warehouse',
    WarehouseLocation: 'WarehouseLocation',
    StockBalance: 'StockBalance',
    StockMovement: 'StockMovement',
    InventorySession: 'InventorySession',
    InventorySessionLine: 'InventorySessionLine',
    SubscriptionEmailNotification: 'SubscriptionEmailNotification',
    SubscriptionPaymentBlockWaiver: 'SubscriptionPaymentBlockWaiver',
    SupportTicket: 'SupportTicket',
    SupportTicketMessage: 'SupportTicketMessage',
    SupportTicketAttachment: 'SupportTicketAttachment',
    SupportTicketEvent: 'SupportTicketEvent',
    SystemConfig: 'SystemConfig',
    QueueMetric: 'QueueMetric',
    JobExecution: 'JobExecution',
    RedisMetric: 'RedisMetric',
    TenantAdditionalVatId: 'TenantAdditionalVatId',
    TenantHealthFinding: 'TenantHealthFinding',
    TenantMembershipAuditLog: 'TenantMembershipAuditLog',
    TenantStripeCustomer: 'TenantStripeCustomer',
    Tenant: 'Tenant',
    TenantUser: 'TenantUser',
    TenantPaymentMethod: 'TenantPaymentMethod',
    TenantUnitOfMeasure: 'TenantUnitOfMeasure',
    TenantVatRate: 'TenantVatRate',
    TenantSettings: 'TenantSettings',
    TenantPayment: 'TenantPayment',
    TenantPlanHistory: 'TenantPlanHistory',
    User: 'User',
    UserTablePreference: 'UserTablePreference',
    RefreshToken: 'RefreshToken',
    Session: 'Session',
    CsrfToken: 'CsrfToken',
    PasswordResetToken: 'PasswordResetToken',
    EmailVerificationToken: 'EmailVerificationToken',
    TenantInvitation: 'TenantInvitation',
    TrustedDevice: 'TrustedDevice',
    WebLoginRequest: 'WebLoginRequest',
    WebAuthnCredential: 'WebAuthnCredential',
    WebAuthnChallenge: 'WebAuthnChallenge',
    ServiceTariff: 'ServiceTariff',
    WorkReport: 'WorkReport',
    WorkReportCodeCounter: 'WorkReportCodeCounter',
    TechnicianCostRate: 'TechnicianCostRate',
    WorkReportSession: 'WorkReportSession',
    WorkReportActivity: 'WorkReportActivity',
    WorkReportLine: 'WorkReportLine',
    WorkReportPublication: 'WorkReportPublication',
    WorkReportShareLink: 'WorkReportShareLink',
    WorkReportEvent: 'WorkReportEvent',
    WorkReportTravelSettings: 'WorkReportTravelSettings'
};
export const TransactionIsolationLevel = runtime.makeStrictEnum({
    ReadUncommitted: 'ReadUncommitted',
    ReadCommitted: 'ReadCommitted',
    RepeatableRead: 'RepeatableRead',
    Serializable: 'Serializable'
});
export const AccountBalanceRecalculationScalarFieldEnum = {
    accountId: 'accountId',
    tenantId: 'tenantId',
    requestedVersion: 'requestedVersion',
    completedVersion: 'completedVersion',
    claimedVersion: 'claimedVersion',
    owner: 'owner',
    leaseUntil: 'leaseUntil',
    attempts: 'attempts',
    nextRunAt: 'nextRunAt',
    requestedAt: 'requestedAt',
    completedAt: 'completedAt',
    lastError: 'lastError',
    pendingSince: 'pendingSince',
    lastAlertAt: 'lastAlertAt'
};
export const AccountMergeDecisionScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    sourceAccountId: 'sourceAccountId',
    targetAccountId: 'targetAccountId',
    decision: 'decision',
    report: 'report',
    decidedByUserId: 'decidedByUserId',
    createdAt: 'createdAt'
};
export const AccountTransferScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    sourceMovementId: 'sourceMovementId',
    destinationMovementId: 'destinationMovementId',
    sourceAccountId: 'sourceAccountId',
    destinationAccountId: 'destinationAccountId',
    amount: 'amount',
    feeAmount: 'feeAmount',
    status: 'status',
    matchConfidence: 'matchConfidence',
    matchMethod: 'matchMethod',
    matchReasons: 'matchReasons',
    note: 'note',
    sourcePreviousCategoryId: 'sourcePreviousCategoryId',
    destinationPreviousCategoryId: 'destinationPreviousCategoryId',
    sourcePreviousExcluded: 'sourcePreviousExcluded',
    destinationPreviousExcluded: 'destinationPreviousExcluded',
    createdBy: 'createdBy',
    confirmedBy: 'confirmedBy',
    confirmedAt: 'confirmedAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const AccountTransferSuggestionScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    sourceMovementId: 'sourceMovementId',
    destinationMovementId: 'destinationMovementId',
    confidence: 'confidence',
    matchMethod: 'matchMethod',
    reasons: 'reasons',
    requiresManualReview: 'requiresManualReview',
    ambiguityGroupKey: 'ambiguityGroupKey',
    blockedReason: 'blockedReason',
    status: 'status',
    reviewedAt: 'reviewedAt',
    reviewedBy: 'reviewedBy',
    dismissReason: 'dismissReason',
    createdTransferId: 'createdTransferId',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const AccountTransferEventScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    transferId: 'transferId',
    type: 'type',
    actorUserId: 'actorUserId',
    metadata: 'metadata',
    createdAt: 'createdAt'
};
export const AcubeF24FormScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    tenantId: 'tenantId',
    acubeUuid: 'acubeUuid',
    fiscalId: 'fiscalId',
    referenceYear: 'referenceYear',
    protocolNumber: 'protocolNumber',
    status: 'status',
    paymentDate: 'paymentDate',
    amount: 'amount',
    receiptAvailable: 'receiptAvailable',
    formPdfGcsPath: 'formPdfGcsPath',
    receiptPdfGcsPath: 'receiptPdfGcsPath',
    receiptStoredAt: 'receiptStoredAt',
    reviewStatus: 'reviewStatus',
    matchKind: 'matchKind',
    matchEvaluatedAt: 'matchEvaluatedAt',
    documentId: 'documentId',
    scheduleId: 'scheduleId',
    f24DelegationId: 'f24DelegationId',
    acubeCreatedAt: 'acubeCreatedAt'
};
export const AcubeJobLogScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    externalUuid: 'externalUuid',
    tenantId: 'tenantId',
    jobType: 'jobType',
    status: 'status',
    fiscalId: 'fiscalId',
    periodFrom: 'periodFrom',
    periodTo: 'periodTo',
    parameters: 'parameters',
    downloadable: 'downloadable',
    webhookReceivedAt: 'webhookReceivedAt',
    scheduledAt: 'scheduledAt',
    startedAt: 'startedAt',
    completedAt: 'completedAt',
    acubeCreatedAt: 'acubeCreatedAt',
    output: 'output',
    errorMessage: 'errorMessage'
};
export const AcubePaymentScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    tenantId: 'tenantId',
    externalUuid: 'externalUuid',
    sepaPaymentId: 'sepaPaymentId',
    accountId: 'accountId',
    accountUuid: 'accountUuid',
    remoteStatus: 'remoteStatus',
    mappedStatus: 'mappedStatus',
    direction: 'direction',
    directionRaw: 'directionRaw',
    system: 'system',
    amount: 'amount',
    currencyCode: 'currencyCode',
    description: 'description',
    endToEndId: 'endToEndId',
    counterpartName: 'counterpartName',
    counterpartIban: 'counterpartIban',
    errorClass: 'errorClass',
    errorMessage: 'errorMessage',
    acubeCreatedAt: 'acubeCreatedAt',
    acubeUpdatedAt: 'acubeUpdatedAt',
    executedAt: 'executedAt',
    webhookReceivedAt: 'webhookReceivedAt',
    lastSyncedAt: 'lastSyncedAt',
    lastSource: 'lastSource',
    orphanReviewedAt: 'orphanReviewedAt',
    orphanReviewedRemoteStatus: 'orphanReviewedRemoteStatus',
    payload: 'payload'
};
export const SepaPaymentAdminEventScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    sepaPaymentId: 'sepaPaymentId',
    externalPaymentId: 'externalPaymentId',
    type: 'type',
    fromStatus: 'fromStatus',
    toStatus: 'toStatus',
    actorUserId: 'actorUserId',
    actorName: 'actorName',
    note: 'note',
    metadata: 'metadata',
    createdAt: 'createdAt'
};
export const AdminNotificationScalarFieldEnum = {
    id: 'id',
    title: 'title',
    message: 'message',
    status: 'status',
    isGlobal: 'isGlobal',
    scheduledAt: 'scheduledAt',
    sentAt: 'sentAt',
    createdById: 'createdById',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const AdminNotificationTenantScalarFieldEnum = {
    id: 'id',
    adminNotificationId: 'adminNotificationId',
    tenantId: 'tenantId'
};
export const AdvisorProfileScalarFieldEnum = {
    id: 'id',
    userId: 'userId',
    firmName: 'firmName',
    vatId: 'vatId',
    fiscalCode: 'fiscalCode',
    country: 'country',
    city: 'city',
    province: 'province',
    postalCode: 'postalCode',
    address: 'address',
    registrationNumber: 'registrationNumber',
    registrationProvince: 'registrationProvince',
    phone: 'phone',
    pec: 'pec',
    isVerified: 'isVerified',
    provisionedByBackoffice: 'provisionedByBackoffice',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const AdvisorAccessLogScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    userId: 'userId',
    event: 'event',
    createdAt: 'createdAt'
};
export const AdvisorTenantSnapshotScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    payload: 'payload',
    computedAt: 'computedAt'
};
export const AITokenUsageScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    userId: 'userId',
    model: 'model',
    serviceType: 'serviceType',
    inputTokens: 'inputTokens',
    outputTokens: 'outputTokens',
    totalTokens: 'totalTokens',
    requestId: 'requestId',
    metadata: 'metadata',
    createdAt: 'createdAt'
};
export const AITokenUsageMonthlyScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    model: 'model',
    year: 'year',
    month: 'month',
    inputTokens: 'inputTokens',
    cachedInputTokens: 'cachedInputTokens',
    cacheWriteInputTokens: 'cacheWriteInputTokens',
    outputTokens: 'outputTokens',
    reasoningTokens: 'reasoningTokens',
    totalTokens: 'totalTokens',
    requestCount: 'requestCount',
    estimatedRequestCount: 'estimatedRequestCount',
    unpricedRequestCount: 'unpricedRequestCount',
    estimatedCost: 'estimatedCost',
    updatedAt: 'updatedAt'
};
export const AIQuotaScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    monthlyTokenLimit: 'monthlyTokenLimit',
    monthlyBudgetLimit: 'monthlyBudgetLimit',
    isUnlimited: 'isUnlimited',
    alertThreshold: 'alertThreshold',
    hardLimit: 'hardLimit',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const AISystemTokenUsageScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    userId: 'userId',
    model: 'model',
    serviceType: 'serviceType',
    inputTokens: 'inputTokens',
    cachedInputTokens: 'cachedInputTokens',
    cacheWriteInputTokens: 'cacheWriteInputTokens',
    outputTokens: 'outputTokens',
    reasoningTokens: 'reasoningTokens',
    totalTokens: 'totalTokens',
    vendor: 'vendor',
    requestId: 'requestId',
    providerRequestId: 'providerRequestId',
    feature: 'feature',
    modelRole: 'modelRole',
    modelVariant: 'modelVariant',
    modelProfile: 'modelProfile',
    usageSource: 'usageSource',
    status: 'status',
    serviceTier: 'serviceTier',
    pricingVersion: 'pricingVersion',
    pricingFound: 'pricingFound',
    estimatedCost: 'estimatedCost',
    actualCost: 'actualCost',
    reservationId: 'reservationId',
    metadata: 'metadata',
    createdAt: 'createdAt'
};
export const AISystemTokenUsageMonthlyScalarFieldEnum = {
    id: 'id',
    model: 'model',
    serviceType: 'serviceType',
    vendor: 'vendor',
    year: 'year',
    month: 'month',
    inputTokens: 'inputTokens',
    cachedInputTokens: 'cachedInputTokens',
    cacheWriteInputTokens: 'cacheWriteInputTokens',
    outputTokens: 'outputTokens',
    reasoningTokens: 'reasoningTokens',
    totalTokens: 'totalTokens',
    requestCount: 'requestCount',
    estimatedRequestCount: 'estimatedRequestCount',
    unpricedRequestCount: 'unpricedRequestCount',
    estimatedCost: 'estimatedCost',
    updatedAt: 'updatedAt'
};
export const AISystemQuotaScalarFieldEnum = {
    id: 'id',
    monthlyTokenLimit: 'monthlyTokenLimit',
    monthlyBudgetLimit: 'monthlyBudgetLimit',
    alertThreshold: 'alertThreshold',
    hardLimit: 'hardLimit',
    isActive: 'isActive',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const AIUsageReservationScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    userId: 'userId',
    serviceType: 'serviceType',
    estimatedTokens: 'estimatedTokens',
    estimatedCost: 'estimatedCost',
    status: 'status',
    expiresAt: 'expiresAt',
    createdAt: 'createdAt',
    settledAt: 'settledAt'
};
export const AIProviderReconciliationScalarFieldEnum = {
    id: 'id',
    vendor: 'vendor',
    periodStart: 'periodStart',
    periodEnd: 'periodEnd',
    estimatedCost: 'estimatedCost',
    actualCost: 'actualCost',
    variance: 'variance',
    currency: 'currency',
    source: 'source',
    ledgerRequestCount: 'ledgerRequestCount',
    status: 'status',
    errorMessage: 'errorMessage',
    metadata: 'metadata',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    reconciledAt: 'reconciledAt'
};
export const AIQueryHistoryScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    userId: 'userId',
    content: 'content',
    normalizedContent: 'normalizedContent',
    createdAt: 'createdAt',
    lastUsedAt: 'lastUsedAt',
    useCount: 'useCount',
    deletedAt: 'deletedAt'
};
export const BankImportEnrichmentJobScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    accountId: 'accountId',
    userId: 'userId',
    accountType: 'accountType',
    movementIds: 'movementIds',
    status: 'status',
    attempts: 'attempts',
    owner: 'owner',
    leaseUntil: 'leaseUntil',
    nextRunAt: 'nextRunAt',
    lastError: 'lastError',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const BankSyncCheckpointScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    accountId: 'accountId',
    provider: 'provider',
    connectionId: 'connectionId',
    updatesThrough: 'updatesThrough',
    historyCheckedAt: 'historyCheckedAt',
    updatedAt: 'updatedAt'
};
export const BankSyncTransactionScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    accountId: 'accountId',
    importSource: 'importSource',
    externalId: 'externalId',
    status: 'status',
    movementId: 'movementId',
    candidateMovementIds: 'candidateMovementIds',
    reason: 'reason',
    payload: 'payload',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const AccountScalarFieldEnum = {
    bankInstitutionCompanyId: 'bankInstitutionCompanyId',
    forecastHistoryPolicy: 'forecastHistoryPolicy',
    id: 'id',
    tenantId: 'tenantId',
    name: 'name',
    bankName: 'bankName',
    type: 'type',
    iban: 'iban',
    identifier: 'identifier',
    balance: 'balance',
    currency: 'currency',
    nativeBalance: 'nativeBalance',
    creditLimit: 'creditLimit',
    creditLimitSource: 'creditLimitSource',
    overdraftExpiresAt: 'overdraftExpiresAt',
    overdraftExpiresAtSource: 'overdraftExpiresAtSource',
    isDefault: 'isDefault',
    isArchived: 'isArchived',
    isAutoSync: 'isAutoSync',
    limitSuspendedAt: 'limitSuspendedAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    provider: 'provider',
    externalId: 'externalId',
    openBankingConsentExpiresAt: 'openBankingConsentExpiresAt',
    lastSyncedAt: 'lastSyncedAt',
    supportedPaymentProducts: 'supportedPaymentProducts',
    onboardingStatus: 'onboardingStatus',
    detectedClosingDay: 'detectedClosingDay',
    linkedBankAccountId: 'linkedBankAccountId',
    linkedBankAccountSource: 'linkedBankAccountSource',
    parentAccountId: 'parentAccountId',
    accountGroupId: 'accountGroupId',
    providerConnectionId: 'providerConnectionId',
    mergedIntoAccountId: 'mergedIntoAccountId',
    siaCode: 'siaCode',
    isPortfolioSbf: 'isPortfolioSbf',
    linkedPortfolioAccountId: 'linkedPortfolioAccountId',
    linkedPortfolioAccountSource: 'linkedPortfolioAccountSource',
    balanceAlertThreshold: 'balanceAlertThreshold'
};
export const CashMovementScalarFieldEnum = {
    commissionDetectionRule: 'commissionDetectionRule',
    bankFeeCompanySource: 'bankFeeCompanySource',
    id: 'id',
    tenantId: 'tenantId',
    accountId: 'accountId',
    companyId: 'companyId',
    categoryId: 'categoryId',
    externalId: 'externalId',
    providerReference: 'providerReference',
    providerFeeAmount: 'providerFeeAmount',
    providerEventCode: 'providerEventCode',
    type: 'type',
    amount: 'amount',
    originalAmount: 'originalAmount',
    originalCurrency: 'originalCurrency',
    exchangeRate: 'exchangeRate',
    rateDate: 'rateDate',
    rateSource: 'rateSource',
    movementDate: 'movementDate',
    description: 'description',
    note: 'note',
    isReconciled: 'isReconciled',
    reconciledAt: 'reconciledAt',
    reconciliationState: 'reconciliationState',
    reconciledAmount: 'reconciledAmount',
    autoMatchCheckedAt: 'autoMatchCheckedAt',
    autoMatchVersion: 'autoMatchVersion',
    autoMatchDiagnostics: 'autoMatchDiagnostics',
    rejectedMatchFingerprints: 'rejectedMatchFingerprints',
    isExcludedFromReconciliation: 'isExcludedFromReconciliation',
    importSource: 'importSource',
    importVersion: 'importVersion',
    affectsAccountBalance: 'affectsAccountBalance',
    commissionSuggestionDismissedAt: 'commissionSuggestionDismissedAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    isInternalTransfer: 'isInternalTransfer',
    internalTransferId: 'internalTransferId'
};
export const CashMovementAllocationScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    cashMovementId: 'cashMovementId',
    documentPaymentScheduleId: 'documentPaymentScheduleId',
    forecastPaymentScheduleId: 'forecastPaymentScheduleId',
    amount: 'amount',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    isAdvance: 'isAdvance',
    isNetting: 'isNetting',
    nettingGroupId: 'nettingGroupId',
    invoiceAdvanceOperationId: 'invoiceAdvanceOperationId'
};
export const CashMovementSplitScalarFieldEnum = {
    bankFeeCompanySource: 'bankFeeCompanySource',
    id: 'id',
    tenantId: 'tenantId',
    cashMovementId: 'cashMovementId',
    amount: 'amount',
    categoryId: 'categoryId',
    companyId: 'companyId',
    note: 'note',
    categoryCleared: 'categoryCleared',
    isVariance: 'isVariance',
    source: 'source',
    createdBy: 'createdBy',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const CashMovementEmbeddingScalarFieldEnum = {
    id: 'id',
    cashMovementId: 'cashMovementId',
    model: 'model',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const ImportTemplateScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    name: 'name',
    description: 'description',
    columnMapping: 'columnMapping',
    dateFormat: 'dateFormat',
    delimiter: 'delimiter',
    encoding: 'encoding',
    hasHeader: 'hasHeader',
    usageCount: 'usageCount',
    lastUsedAt: 'lastUsedAt',
    isOfficial: 'isOfficial',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const ImportHistoryScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    accountId: 'accountId',
    templateId: 'templateId',
    fileName: 'fileName',
    totalRows: 'totalRows',
    successRows: 'successRows',
    errorRows: 'errorRows',
    duplicateRows: 'duplicateRows',
    errors: 'errors',
    details: 'details',
    importedAt: 'importedAt',
    importedBy: 'importedBy'
};
export const AccountBalanceScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    accountId: 'accountId',
    balance: 'balance',
    balanceDate: 'balanceDate',
    source: 'source',
    isOpeningBalance: 'isOpeningBalance',
    notes: 'notes',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const InternalTransferScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    sourceMovementId: 'sourceMovementId',
    sourceAccountId: 'sourceAccountId',
    sourcePreviousCategoryId: 'sourcePreviousCategoryId',
    sourcePreviousExcluded: 'sourcePreviousExcluded',
    periodStartDate: 'periodStartDate',
    periodEndDate: 'periodEndDate',
    totalSourceAmount: 'totalSourceAmount',
    totalCardAmount: 'totalCardAmount',
    commissionAmount: 'commissionAmount',
    commissionMovementId: 'commissionMovementId',
    isAutomatic: 'isAutomatic',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    createdBy: 'createdBy'
};
export const InternalTransferLinkScalarFieldEnum = {
    id: 'id',
    internalTransferId: 'internalTransferId',
    targetAccountId: 'targetAccountId',
    movementCount: 'movementCount',
    totalAmount: 'totalAmount',
    createdAt: 'createdAt'
};
export const InternalTransferSuggestionScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    movementId: 'movementId',
    confidence: 'confidence',
    matchType: 'matchType',
    detectedPattern: 'detectedPattern',
    detectedIssuer: 'detectedIssuer',
    suggestedTargets: 'suggestedTargets',
    mathMatchResult: 'mathMatchResult',
    status: 'status',
    reviewedAt: 'reviewedAt',
    reviewedBy: 'reviewedBy',
    dismissReason: 'dismissReason',
    createdTransferId: 'createdTransferId',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const LearnedTransferPatternScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    pattern: 'pattern',
    sourceAccountId: 'sourceAccountId',
    targetAccountIds: 'targetAccountIds',
    learnedFromTransferId: 'learnedFromTransferId',
    timesMatched: 'timesMatched',
    lastMatchedAt: 'lastMatchedAt',
    isActive: 'isActive',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const InvoiceAdvanceOperationScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    distintaRibaId: 'distintaRibaId',
    disbursementMovementId: 'disbursementMovementId',
    advancePercent: 'advancePercent',
    advancedAmount: 'advancedAmount',
    status: 'status',
    settlementMovementId: 'settlementMovementId',
    settledAt: 'settledAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const CarrierScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    name: 'name',
    vatNumber: 'vatNumber',
    fiscalCode: 'fiscalCode',
    street: 'street',
    city: 'city',
    province: 'province',
    postalCode: 'postalCode',
    country: 'country',
    phone: 'phone',
    email: 'email',
    notes: 'notes',
    isDefault: 'isDefault',
    isActive: 'isActive',
    sortOrder: 'sortOrder',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const CategoryScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    name: 'name',
    description: 'description',
    icon: 'icon',
    color: 'color',
    flowType: 'flowType',
    parentId: 'parentId',
    isEditable: 'isEditable',
    isDeletable: 'isDeletable',
    isSuggestible: 'isSuggestible',
    isSystem: 'isSystem',
    forecastSortOrder: 'forecastSortOrder',
    forecastHideWhenZero: 'forecastHideWhenZero',
    archivedAt: 'archivedAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const CategoryKeywordScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    categoryId: 'categoryId',
    keyword: 'keyword',
    weight: 'weight',
    caseSensitive: 'caseSensitive',
    createdBy: 'createdBy',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const CategoryFeedbackScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    entityType: 'entityType',
    companyId: 'companyId',
    flowType: 'flowType',
    documentType: 'documentType',
    categoryId: 'categoryId',
    feedbackCount: 'feedbackCount',
    lastUserId: 'lastUserId',
    autoApply: 'autoApply',
    autoApplyDisabled: 'autoApplyDisabled',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const CollectionAccountScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    name: 'name',
    iban: 'iban',
    bic: 'bic',
    bankName: 'bankName',
    beneficiary: 'beneficiary',
    isDefault: 'isDefault',
    isActive: 'isActive',
    sortOrder: 'sortOrder',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const CommessaScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    code: 'code',
    name: 'name',
    companyId: 'companyId',
    status: 'status',
    contractValue: 'contractValue',
    costBudget: 'costBudget',
    startDate: 'startDate',
    endDate: 'endDate',
    notes: 'notes',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const CommessaAttachmentScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    commessaId: 'commessaId',
    fileName: 'fileName',
    contentType: 'contentType',
    description: 'description',
    gcsBucket: 'gcsBucket',
    gcsPath: 'gcsPath',
    size: 'size',
    uploadedById: 'uploadedById',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const CommessaDocumentAllocationScalarFieldEnum = {
    id: 'id',
    documentId: 'documentId',
    commessaId: 'commessaId',
    amount: 'amount',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const CommessaCodeCounterScalarFieldEnum = {
    tenantId: 'tenantId',
    year: 'year',
    lastProgressive: 'lastProgressive',
    updatedAt: 'updatedAt'
};
export const CompanyScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    displayName: 'displayName',
    legalName: 'legalName',
    companyType: 'companyType',
    role: 'role',
    isEmployee: 'isEmployee',
    jobTitle: 'jobTitle',
    vatNumber: 'vatNumber',
    taxCode: 'taxCode',
    viesVerifiedAt: 'viesVerifiedAt',
    defaultIncomingCategoryId: 'defaultIncomingCategoryId',
    defaultOutgoingCategoryId: 'defaultOutgoingCategoryId',
    street: 'street',
    city: 'city',
    province: 'province',
    postalCode: 'postalCode',
    country: 'country',
    pec: 'pec',
    sdiCode: 'sdiCode',
    email: 'email',
    phone: 'phone',
    website: 'website',
    notes: 'notes',
    excludeFromPaymentReminders: 'excludeFromPaymentReminders',
    taxRegimeFiscale: 'taxRegimeFiscale',
    reaOffice: 'reaOffice',
    reaNumber: 'reaNumber',
    shareCapital: 'shareCapital',
    soleOwner: 'soleOwner',
    liquidationStatus: 'liquidationStatus',
    administrationRef: 'administrationRef',
    jetHrEmployeeUuid: 'jetHrEmployeeUuid',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const CompanyBankAccountScalarFieldEnum = {
    id: 'id',
    companyId: 'companyId',
    iban: 'iban',
    isDefault: 'isDefault',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const CompanyPaReferenceScalarFieldEnum = {
    id: 'id',
    companyId: 'companyId',
    description: 'description',
    referenceType: 'referenceType',
    referenceId: 'referenceId',
    referenceDate: 'referenceDate',
    cig: 'cig',
    cup: 'cup',
    active: 'active',
    validFrom: 'validFrom',
    validTo: 'validTo',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const ConsentLogScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    userId: 'userId',
    userEmail: 'userEmail',
    acceptedTerms: 'acceptedTerms',
    acceptedSpecificClauses: 'acceptedSpecificClauses',
    documentVersion: 'documentVersion',
    ipAddress: 'ipAddress',
    userAgent: 'userAgent',
    createdAt: 'createdAt'
};
export const ContractScalarFieldEnum = {
    autoRenew: 'autoRenew',
    billingSync: 'billingSync',
    companyEconomics: 'companyEconomics',
    invoiceBillingFrequency: 'invoiceBillingFrequency',
    id: 'id',
    type: 'type',
    status: 'status',
    demoEnvironment: 'demoEnvironment',
    remoteDemoId: 'remoteDemoId',
    parentContractId: 'parentContractId',
    effectiveFrom: 'effectiveFrom',
    changeReason: 'changeReason',
    companyName: 'companyName',
    vatId: 'vatId',
    fiscalCode: 'fiscalCode',
    taxSubjectType: 'taxSubjectType',
    taxRegimeCode: 'taxRegimeCode',
    address: 'address',
    city: 'city',
    province: 'province',
    postalCode: 'postalCode',
    country: 'country',
    signerName: 'signerName',
    signerEmail: 'signerEmail',
    signerPhone: 'signerPhone',
    sdiCode: 'sdiCode',
    pec: 'pec',
    billingEmail: 'billingEmail',
    planName: 'planName',
    billingPeriod: 'billingPeriod',
    subscriptionFee: 'subscriptionFee',
    activationFee: 'activationFee',
    proratedFee: 'proratedFee',
    invoicingMode: 'invoicingMode',
    invoiceMonthlyLimit: 'invoiceMonthlyLimit',
    invoiceAnnualLimit: 'invoiceAnnualLimit',
    bankEntityLimit: 'bankEntityLimit',
    taxDrawerLimit: 'taxDrawerLimit',
    taxDrawerDocumentMonthlyLimit: 'taxDrawerDocumentMonthlyLimit',
    taxDrawerDocumentAnnualLimit: 'taxDrawerDocumentAnnualLimit',
    f24AnnualLimit: 'f24AnnualLimit',
    userLimit: 'userLimit',
    companyLimit: 'companyLimit',
    extraUserMonthlyPrice: 'extraUserMonthlyPrice',
    technicianLimit: 'technicianLimit',
    warehouseLimit: 'warehouseLimit',
    esdiConnectionLimit: 'esdiConnectionLimit',
    infrastructureCostMonthly: 'infrastructureCostMonthly',
    grossMarginSnapshot: 'grossMarginSnapshot',
    annualRecurringMarginSnapshot: 'annualRecurringMarginSnapshot',
    firstYearMarginSnapshot: 'firstYearMarginSnapshot',
    targetGrossMarginSnapshot: 'targetGrossMarginSnapshot',
    costSnapshotAt: 'costSnapshotAt',
    pricingBreakdown: 'pricingBreakdown',
    commercialOptions: 'commercialOptions',
    previousConfiguration: 'previousConfiguration',
    supersededAt: 'supersededAt',
    supersededByContractId: 'supersededByContractId',
    paymentMethod: 'paymentMethod',
    paymentInstallments: 'paymentInstallments',
    paymentNotes: 'paymentNotes',
    specialConditions: 'specialConditions',
    signTokenHash: 'signTokenHash',
    signTokenExpires: 'signTokenExpires',
    otpHash: 'otpHash',
    otpExpires: 'otpExpires',
    otpAttempts: 'otpAttempts',
    otpRequestCount: 'otpRequestCount',
    otpLastSentAt: 'otpLastSentAt',
    pdfPath: 'pdfPath',
    signedPdfPath: 'signedPdfPath',
    documentHash: 'documentHash',
    customPdf: 'customPdf',
    sentAt: 'sentAt',
    viewedAt: 'viewedAt',
    signedAt: 'signedAt',
    signedIp: 'signedIp',
    signedUserAgent: 'signedUserAgent',
    dataConfirmedAt: 'dataConfirmedAt',
    demoExpiresAt: 'demoExpiresAt',
    convertedToContractId: 'convertedToContractId',
    tenantId: 'tenantId',
    serviceRecipient: 'serviceRecipient',
    serviceRecipientTenantId: 'serviceRecipientTenantId',
    referrerId: 'referrerId',
    createdById: 'createdById',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const TenantCommercialEntitlementScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    contractId: 'contractId',
    periodStart: 'periodStart',
    periodEnd: 'periodEnd',
    invoiceAnnualLimit: 'invoiceAnnualLimit',
    bankEntityLimit: 'bankEntityLimit',
    taxDrawerLimit: 'taxDrawerLimit',
    taxDrawerDocumentAnnualLimit: 'taxDrawerDocumentAnnualLimit',
    f24AnnualLimit: 'f24AnnualLimit',
    userLimit: 'userLimit',
    companyLimit: 'companyLimit',
    extraUserMonthlyPrice: 'extraUserMonthlyPrice',
    technicianLimit: 'technicianLimit',
    warehouseLimit: 'warehouseLimit',
    bankLimitPerAccount: 'bankLimitPerAccount',
    modules: 'modules',
    modulesEnforced: 'modulesEnforced',
    invoicingMode: 'invoicingMode',
    commercialOptions: 'commercialOptions',
    activationStatus: 'activationStatus',
    directDebitEnabled: 'directDebitEnabled',
    active: 'active',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const TenantCommercialUsageCounterScalarFieldEnum = {
    id: 'id',
    entitlementId: 'entitlementId',
    metric: 'metric',
    used: 'used',
    periodStart: 'periodStart',
    periodEnd: 'periodEnd',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const CommercialCapacityRequestScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    requesterUserId: 'requesterUserId',
    assignedToUserId: 'assignedToUserId',
    entitlementId: 'entitlementId',
    sourceContractId: 'sourceContractId',
    resultingContractId: 'resultingContractId',
    metric: 'metric',
    currentLimit: 'currentLimit',
    requestedLimit: 'requestedLimit',
    note: 'note',
    status: 'status',
    resolvedAt: 'resolvedAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const ContractEventScalarFieldEnum = {
    id: 'id',
    contractId: 'contractId',
    type: 'type',
    ipAddress: 'ipAddress',
    userAgent: 'userAgent',
    metadata: 'metadata',
    createdAt: 'createdAt'
};
export const CommercialUsageWarningViewScalarFieldEnum = {
    entitlementId: 'entitlementId',
    userId: 'userId',
    metric: 'metric',
    threshold: 'threshold',
    createdAt: 'createdAt'
};
export const CommercialUsageWarningClaimScalarFieldEnum = {
    id: 'id',
    entitlementId: 'entitlementId',
    userId: 'userId',
    metric: 'metric',
    threshold: 'threshold',
    expiresAt: 'expiresAt',
    confirmedAt: 'confirmedAt',
    createdAt: 'createdAt'
};
export const CommercialUsageAlertScalarFieldEnum = {
    id: 'id',
    entitlementId: 'entitlementId',
    metric: 'metric',
    threshold: 'threshold',
    used: 'used',
    limit: 'limit',
    emailPayload: 'emailPayload',
    emailSentAt: 'emailSentAt',
    firstAttemptAt: 'firstAttemptAt',
    nextAttemptAt: 'nextAttemptAt',
    attempts: 'attempts',
    leaseToken: 'leaseToken',
    leaseUntil: 'leaseUntil',
    reviewRequiredAt: 'reviewRequiredAt',
    lastError: 'lastError',
    createdAt: 'createdAt'
};
export const CounterpartMaterialScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    companyId: 'companyId',
    direction: 'direction',
    reason: 'reason',
    description: 'description',
    productId: 'productId',
    quantity: 'quantity',
    returnedQuantity: 'returnedQuantity',
    unitOfMeasure: 'unitOfMeasure',
    movedAt: 'movedAt',
    documentId: 'documentId',
    documentLineId: 'documentLineId',
    notes: 'notes',
    createdById: 'createdById',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const CounterpartMaterialReturnScalarFieldEnum = {
    id: 'id',
    materialId: 'materialId',
    quantity: 'quantity',
    returnedAt: 'returnedAt',
    documentId: 'documentId',
    notes: 'notes',
    createdById: 'createdById',
    createdAt: 'createdAt'
};
export const CustomerMachineScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    code: 'code',
    name: 'name',
    category: 'category',
    brand: 'brand',
    model: 'model',
    serialNumber: 'serialNumber',
    serialNumberKey: 'serialNumberKey',
    productId: 'productId',
    status: 'status',
    installationDate: 'installationDate',
    warrantyStartDate: 'warrantyStartDate',
    warrantyEndDate: 'warrantyEndDate',
    warrantyProvider: 'warrantyProvider',
    warrantyNotes: 'warrantyNotes',
    firmwareVersion: 'firmwareVersion',
    firmwareRecordedAt: 'firmwareRecordedAt',
    notes: 'notes',
    archivedAt: 'archivedAt',
    version: 'version',
    createdById: 'createdById',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const MachineAssignmentScalarFieldEnum = {
    id: 'id',
    machineId: 'machineId',
    companyId: 'companyId',
    kind: 'kind',
    startDate: 'startDate',
    endDate: 'endDate',
    address: 'address',
    city: 'city',
    postalCode: 'postalCode',
    province: 'province',
    country: 'country',
    location: 'location',
    reason: 'reason',
    createdById: 'createdById',
    createdAt: 'createdAt'
};
export const MachineCoverageScalarFieldEnum = {
    id: 'id',
    machineId: 'machineId',
    contractId: 'contractId',
    startDate: 'startDate',
    endDate: 'endDate',
    notes: 'notes',
    createdById: 'createdById',
    createdAt: 'createdAt'
};
export const WorkReportMachineScalarFieldEnum = {
    id: 'id',
    workReportId: 'workReportId',
    machineId: 'machineId',
    sortOrder: 'sortOrder',
    machineSnapshot: 'machineSnapshot'
};
export const MachineChecklistScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    code: 'code',
    name: 'name',
    description: 'description',
    category: 'category',
    items: 'items',
    isActive: 'isActive',
    version: 'version',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const MachineCheckPlanScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    machineId: 'machineId',
    checklistId: 'checklistId',
    name: 'name',
    recurrenceUnit: 'recurrenceUnit',
    recurrenceInterval: 'recurrenceInterval',
    recurrenceAnchor: 'recurrenceAnchor',
    firstDueDate: 'firstDueDate',
    nextDueDate: 'nextDueDate',
    reminderDays: 'reminderDays',
    status: 'status',
    suspendedReason: 'suspendedReason',
    responsibleUserId: 'responsibleUserId',
    notes: 'notes',
    version: 'version',
    createdById: 'createdById',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const MachineCheckScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    machineId: 'machineId',
    companyId: 'companyId',
    planId: 'planId',
    plannedDueDate: 'plannedDueDate',
    satisfiedDueDate: 'satisfiedDueDate',
    checklistId: 'checklistId',
    checklistSnapshot: 'checklistSnapshot',
    answers: 'answers',
    pendingFindings: 'pendingFindings',
    resolvesFindingIds: 'resolvesFindingIds',
    status: 'status',
    outcome: 'outcome',
    notPerformedReason: 'notPerformedReason',
    executedOn: 'executedOn',
    technicianId: 'technicianId',
    location: 'location',
    workReportId: 'workReportId',
    notes: 'notes',
    customerSignerName: 'customerSignerName',
    customerSignaturePath: 'customerSignaturePath',
    customerSignedAt: 'customerSignedAt',
    version: 'version',
    submittedAt: 'submittedAt',
    approvedAt: 'approvedAt',
    approvedById: 'approvedById',
    createdById: 'createdById',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const MachineFindingScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    machineId: 'machineId',
    openedByCheckId: 'openedByCheckId',
    resolvedByCheckId: 'resolvedByCheckId',
    description: 'description',
    severity: 'severity',
    status: 'status',
    resolutionNotes: 'resolutionNotes',
    resolvedAt: 'resolvedAt',
    resolvedById: 'resolvedById',
    createdAt: 'createdAt'
};
export const MachineAttachmentScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    machineId: 'machineId',
    fileName: 'fileName',
    contentType: 'contentType',
    description: 'description',
    gcsBucket: 'gcsBucket',
    gcsPath: 'gcsPath',
    size: 'size',
    uploadedById: 'uploadedById',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const MachineEventScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    machineId: 'machineId',
    type: 'type',
    payload: 'payload',
    actorUserId: 'actorUserId',
    createdAt: 'createdAt'
};
export const DebtScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    documentId: 'documentId',
    debtType: 'debtType',
    originalAmount: 'originalAmount',
    currentBalance: 'currentBalance',
    interestRate: 'interestRate',
    interestType: 'interestType',
    loanStartDate: 'loanStartDate',
    loanEndDate: 'loanEndDate',
    paymentFrequency: 'paymentFrequency',
    paymentDay: 'paymentDay',
    numberOfPayments: 'numberOfPayments',
    creditorName: 'creditorName',
    accountId: 'accountId',
    notes: 'notes',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const DebtPaymentScheduleScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    documentPaymentScheduleId: 'documentPaymentScheduleId',
    principalAmount: 'principalAmount',
    interestAmount: 'interestAmount',
    remainingBalance: 'remainingBalance',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const DscrSnapshotScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    referenceDate: 'referenceDate',
    horizonMonths: 'horizonMonths',
    dscr: 'dscr',
    status: 'status',
    numerator: 'numerator',
    denominator: 'denominator',
    alertsCount: 'alertsCount',
    snapshotData: 'snapshotData',
    createdAt: 'createdAt'
};
export const DocumentAdvanceApplicationScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    advanceDocumentId: 'advanceDocumentId',
    finalDocumentId: 'finalDocumentId',
    amount: 'amount',
    deductionMode: 'deductionMode',
    ordinaryAdvanceConfirmed: 'ordinaryAdvanceConfirmed',
    importedReferenceId: 'importedReferenceId',
    roundingAdjustment: 'roundingAdjustment',
    paymentPlanBefore: 'paymentPlanBefore',
    stateBefore: 'stateBefore',
    createdById: 'createdById',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const DocumentAdvancePlanEventScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    documentId: 'documentId',
    createdById: 'createdById',
    createdAt: 'createdAt',
    before: 'before',
    after: 'after'
};
export const DocumentAdvanceDeductionLineScalarFieldEnum = {
    id: 'id',
    applicationId: 'applicationId',
    lineId: 'lineId'
};
export const DocumentElectronicEventScalarFieldEnum = {
    id: 'id',
    documentId: 'documentId',
    tenantId: 'tenantId',
    eventType: 'eventType',
    occurredAt: 'occurredAt',
    userId: 'userId',
    fileName: 'fileName',
    description: 'description',
    errorDetails: 'errorDetails'
};
export const DocumentSdiNotificationScalarFieldEnum = {
    id: 'id',
    documentId: 'documentId',
    notificationUuid: 'notificationUuid',
    notificationType: 'notificationType',
    fileName: 'fileName',
    message: 'message',
    sdiCreatedAt: 'sdiCreatedAt',
    receivedAt: 'receivedAt',
    rawPayload: 'rawPayload'
};
export const DocumentScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    companyId: 'companyId',
    categoryId: 'categoryId',
    categoryCleared: 'categoryCleared',
    sourceForeignInvoiceDocumentId: 'sourceForeignInvoiceDocumentId',
    direction: 'direction',
    type: 'type',
    number: 'number',
    issueDate: 'issueDate',
    totalAmount: 'totalAmount',
    status: 'status',
    description: 'description',
    source: 'source',
    electronicType: 'electronicType',
    taxableAmount: 'taxableAmount',
    taxAmount: 'taxAmount',
    rounding: 'rounding',
    stampDuty: 'stampDuty',
    virtualStampDuty: 'virtualStampDuty',
    stampDutyAutomatic: 'stampDutyAutomatic',
    stampDutyAmount: 'stampDutyAmount',
    chargeStampDutyToCustomer: 'chargeStampDutyToCustomer',
    stampDutyChargeVatRateId: 'stampDutyChargeVatRateId',
    transmissionFormat: 'transmissionFormat',
    progressiveId: 'progressiveId',
    recipientCode: 'recipientCode',
    recipientPec: 'recipientPec',
    vatExigibility: 'vatExigibility',
    art73: 'art73',
    currency: 'currency',
    taxRegimeCode: 'taxRegimeCode',
    carrierId: 'carrierId',
    carrierVatNumber: 'carrierVatNumber',
    carrierFiscalCode: 'carrierFiscalCode',
    carrierName: 'carrierName',
    transportReason: 'transportReason',
    transportVehicle: 'transportVehicle',
    packagesNumber: 'packagesNumber',
    packagesDescription: 'packagesDescription',
    weightUnit: 'weightUnit',
    grossWeight: 'grossWeight',
    netWeight: 'netWeight',
    pickupDate: 'pickupDate',
    transportStartDate: 'transportStartDate',
    transportCare: 'transportCare',
    transportPort: 'transportPort',
    transportNotes: 'transportNotes',
    pickupStreet: 'pickupStreet',
    pickupCity: 'pickupCity',
    pickupProvince: 'pickupProvince',
    pickupPostalCode: 'pickupPostalCode',
    pickupCountry: 'pickupCountry',
    deliveryStreet: 'deliveryStreet',
    deliveryCity: 'deliveryCity',
    deliveryProvince: 'deliveryProvince',
    deliveryPostalCode: 'deliveryPostalCode',
    deliveryCountry: 'deliveryCountry',
    expiryDate: 'expiryDate',
    internalNote: 'internalNote',
    otherData: 'otherData',
    intentDeclarationId: 'intentDeclarationId',
    paperTemplateKey: 'paperTemplateKey',
    paperAppearanceOverride: 'paperAppearanceOverride',
    externalId: 'externalId',
    acubeSupplierInvoiceUuid: 'acubeSupplierInvoiceUuid',
    numberingSequenceId: 'numberingSequenceId',
    paymentTermId: 'paymentTermId',
    paymentMethodDefault: 'paymentMethodDefault',
    paymentConditionsDefault: 'paymentConditionsDefault',
    warehouseId: 'warehouseId',
    stockMovementEnabled: 'stockMovementEnabled',
    stockMovementPostedAt: 'stockMovementPostedAt',
    debitAccountId: 'debitAccountId',
    payrollPeriod: 'payrollPeriod',
    payrollExtraPay: 'payrollExtraPay',
    parentDocumentId: 'parentDocumentId',
    sourceDocumentId: 'sourceDocumentId',
    validUntil: 'validUntil',
    salesPriceListCode: 'salesPriceListCode',
    acceptedAt: 'acceptedAt',
    rejectedAt: 'rejectedAt',
    rejectionReason: 'rejectionReason',
    customerOrderRef: 'customerOrderRef',
    customerOrderDate: 'customerOrderDate',
    fulfilledAt: 'fulfilledAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    createdById: 'createdById',
    deletedAt: 'deletedAt',
    deletedById: 'deletedById',
    reviewStatus: 'reviewStatus',
    verifiedAt: 'verifiedAt',
    verifiedByUserId: 'verifiedByUserId',
    approvedAt: 'approvedAt',
    approvedByUserId: 'approvedByUserId',
    verifiedByImpersonatorId: 'verifiedByImpersonatorId',
    approvedByImpersonatorId: 'approvedByImpersonatorId'
};
export const DocumentReadReceiptScalarFieldEnum = {
    documentId: 'documentId',
    userId: 'userId',
    readAt: 'readAt'
};
export const DocumentPaymentScheduleScalarFieldEnum = {
    compensatedAmount: 'compensatedAmount',
    id: 'id',
    tenantId: 'tenantId',
    documentId: 'documentId',
    installmentNumber: 'installmentNumber',
    dueDate: 'dueDate',
    amount: 'amount',
    description: 'description',
    reconciliationStatus: 'reconciliationStatus',
    forecastMatchStatus: 'forecastMatchStatus',
    skippedSource: 'skippedSource',
    skippedAt: 'skippedAt',
    paymentMethod: 'paymentMethod',
    iban: 'iban',
    bic: 'bic',
    bankName: 'bankName',
    beneficiary: 'beneficiary',
    paymentConditions: 'paymentConditions',
    financialDiscount: 'financialDiscount',
    reminderCount: 'reminderCount',
    lastReminderAt: 'lastReminderAt',
    externalPaymentId: 'externalPaymentId',
    paymentStatus: 'paymentStatus',
    paymentDate: 'paymentDate',
    paymentErrorMessage: 'paymentErrorMessage',
    paymentAccountId: 'paymentAccountId',
    paymentDescription: 'paymentDescription',
    paymentStatusManuallySet: 'paymentStatusManuallySet',
    sepaPaymentId: 'sepaPaymentId',
    activeF24DelegationId: 'activeF24DelegationId',
    ribaStatus: 'ribaStatus',
    ribaPresentationDate: 'ribaPresentationDate',
    ribaAccountId: 'ribaAccountId',
    distintaRibaId: 'distintaRibaId',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const DistintaRibaScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    code: 'code',
    direction: 'direction',
    status: 'status',
    type: 'type',
    advanceRequestMode: 'advanceRequestMode',
    accountId: 'accountId',
    presentationDate: 'presentationDate',
    totalAmount: 'totalAmount',
    requestedAdvanceAmount: 'requestedAdvanceAmount',
    scheduleCount: 'scheduleCount',
    createdBy: 'createdBy',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const DistintaMovementLinkScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    distintaRibaId: 'distintaRibaId',
    cashMovementId: 'cashMovementId',
    linkStatus: 'linkStatus',
    role: 'role',
    source: 'source',
    confidence: 'confidence',
    metadata: 'metadata',
    createdBy: 'createdBy',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const DistintaRibaEventScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    distintaRibaId: 'distintaRibaId',
    eventType: 'eventType',
    eventDate: 'eventDate',
    amount: 'amount',
    note: 'note',
    payload: 'payload',
    createdBy: 'createdBy',
    createdAt: 'createdAt'
};
export const RibaMirrorLinkScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    distintaRibaId: 'distintaRibaId',
    movementAId: 'movementAId',
    movementBId: 'movementBId',
    confidence: 'confidence',
    createdBy: 'createdBy',
    createdAt: 'createdAt'
};
export const DocumentElectronicFileScalarFieldEnum = {
    id: 'id',
    documentId: 'documentId',
    xmlContent: 'xmlContent',
    xmlHash: 'xmlHash',
    xmlSize: 'xmlSize',
    pdfContent: 'pdfContent',
    pdfSize: 'pdfSize',
    sdiId: 'sdiId',
    sdiFileName: 'sdiFileName',
    receivedAt: 'receivedAt',
    acubeMarking: 'acubeMarking',
    acubeMarkingNotice: 'acubeMarkingNotice',
    acubeSentAt: 'acubeSentAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const DocumentLineScalarFieldEnum = {
    id: 'id',
    documentId: 'documentId',
    lineNumber: 'lineNumber',
    description: 'description',
    quantity: 'quantity',
    unitOfMeasure: 'unitOfMeasure',
    unitPrice: 'unitPrice',
    discount: 'discount',
    markup: 'markup',
    totalPrice: 'totalPrice',
    vatRateId: 'vatRateId',
    categoryId: 'categoryId',
    vatRateValue: 'vatRateValue',
    vatNature: 'vatNature',
    itemCode: 'itemCode',
    competenceStartDate: 'competenceStartDate',
    competenceEndDate: 'competenceEndDate',
    productId: 'productId',
    warehouseId: 'warehouseId',
    warehouseLocationId: 'warehouseLocationId',
    otherData: 'otherData',
    sourceLineId: 'sourceLineId',
    deliveredQuantity: 'deliveredQuantity',
    invoicedQuantity: 'invoicedQuantity',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const DocumentVatSummaryScalarFieldEnum = {
    id: 'id',
    documentId: 'documentId',
    vatRateId: 'vatRateId',
    vatRateValue: 'vatRateValue',
    vatNature: 'vatNature',
    taxableAmount: 'taxableAmount',
    taxAmount: 'taxAmount',
    vatExigibility: 'vatExigibility',
    accessoryCharges: 'accessoryCharges',
    rounding: 'rounding',
    normativeReference: 'normativeReference',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const DocumentWithholdingScalarFieldEnum = {
    id: 'id',
    documentId: 'documentId',
    withholdingType: 'withholdingType',
    causalePagamento: 'causalePagamento',
    taxableAmount: 'taxableAmount',
    withholdingRate: 'withholdingRate',
    withholdingAmount: 'withholdingAmount',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const DocumentSocialSecurityScalarFieldEnum = {
    id: 'id',
    documentId: 'documentId',
    fundType: 'fundType',
    taxableAmount: 'taxableAmount',
    rate: 'rate',
    amount: 'amount',
    vatRate: 'vatRate',
    vatNature: 'vatNature',
    withholding: 'withholding',
    percentageImponibile: 'percentageImponibile',
    administrationReference: 'administrationReference',
    doNotCountInToPay: 'doNotCountInToPay',
    excludeTaxableFromOtherFunds: 'excludeTaxableFromOtherFunds',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const DocumentReferenceScalarFieldEnum = {
    id: 'id',
    documentId: 'documentId',
    referenceType: 'referenceType',
    referenceId: 'referenceId',
    referenceDate: 'referenceDate',
    lineRef: 'lineRef',
    cig: 'cig',
    cup: 'cup',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const DocumentAttachmentScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    documentId: 'documentId',
    fileName: 'fileName',
    contentType: 'contentType',
    description: 'description',
    gcsBucket: 'gcsBucket',
    gcsPath: 'gcsPath',
    size: 'size',
    uploadedById: 'uploadedById',
    content: 'content',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const DocumentEmbeddingScalarFieldEnum = {
    id: 'id',
    documentId: 'documentId',
    model: 'model',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const DocumentPaymentScheduleEmbeddingScalarFieldEnum = {
    id: 'id',
    documentPaymentScheduleId: 'documentPaymentScheduleId',
    model: 'model',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const DocumentCompensationScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    groupId: 'groupId',
    creditNoteId: 'creditNoteId',
    invoiceId: 'invoiceId',
    creditScheduleId: 'creditScheduleId',
    creditScheduleRef: 'creditScheduleRef',
    invoiceScheduleId: 'invoiceScheduleId',
    invoiceScheduleRef: 'invoiceScheduleRef',
    amount: 'amount',
    createdBy: 'createdBy',
    createdAt: 'createdAt',
    cancelledBy: 'cancelledBy',
    cancelledAt: 'cancelledAt'
};
export const ErrorLogAlertSettingsScalarFieldEnum = {
    id: 'id',
    recipients: 'recipients',
    updatedBy: 'updatedBy',
    updatedAt: 'updatedAt'
};
export const ErrorLogScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    level: 'level',
    errorCategoryId: 'errorCategoryId',
    errorCode: 'errorCode',
    tenantId: 'tenantId',
    message: 'message',
    stackTrace: 'stackTrace',
    context: 'context',
    resolved: 'resolved',
    resolvedAt: 'resolvedAt',
    resolvedBy: 'resolvedBy',
    notes: 'notes'
};
export const ErrorCategoryScalarFieldEnum = {
    id: 'id',
    name: 'name',
    totalCount: 'totalCount',
    unresolvedCount: 'unresolvedCount',
    lastOccurrence: 'lastOccurrence',
    lastMessage: 'lastMessage',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const ExchangeRateScalarFieldEnum = {
    id: 'id',
    currency: 'currency',
    rateDate: 'rateDate',
    rate: 'rate',
    source: 'source',
    createdAt: 'createdAt'
};
export const F24DelegationScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    delegaUuid: 'delegaUuid',
    idRichiesta: 'idRichiesta',
    tipo: 'tipo',
    statoSintetico: 'statoSintetico',
    statoInterno: 'statoInterno',
    payload: 'payload',
    affidabilita: 'affidabilita',
    dataVersamento: 'dataVersamento',
    saldoDelega: 'saldoDelega',
    ibanAddebito: 'ibanAddebito',
    accountId: 'accountId',
    emailNotifiche: 'emailNotifiche',
    sourceFileName: 'sourceFileName',
    sourcePage: 'sourcePage',
    sourceSha256: 'sourceSha256',
    sourcePdfGcsPath: 'sourcePdfGcsPath',
    importBatchId: 'importBatchId',
    uploadedByUserId: 'uploadedByUserId',
    cfContribuente: 'cfContribuente',
    denomContribuente: 'denomContribuente',
    dedupHash: 'dedupHash',
    consentGivenAt: 'consentGivenAt',
    consentUserId: 'consentUserId',
    consentUserEmail: 'consentUserEmail',
    consentUserName: 'consentUserName',
    consentIp: 'consentIp',
    consentUserAgent: 'consentUserAgent',
    sentAt: 'sentAt',
    takenInChargeAt: 'takenInChargeAt',
    outcomeAt: 'outcomeAt',
    remoteAmountsMisaligned: 'remoteAmountsMisaligned',
    documentId: 'documentId',
    scheduleId: 'scheduleId',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const FiscalInvoiceRecoveryScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    gapKey: 'gapKey',
    series: 'series',
    year: 'year',
    firstNumber: 'firstNumber',
    lastNumber: 'lastNumber',
    fromDate: 'fromDate',
    toDate: 'toDate',
    firstSeenAt: 'firstSeenAt',
    lastSeenAt: 'lastSeenAt',
    status: 'status',
    reason: 'reason',
    claimedAt: 'claimedAt',
    estimatedDocuments: 'estimatedDocuments',
    updatedAt: 'updatedAt'
};
export const ForecastScenarioScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    name: 'name',
    type: 'type',
    isLocked: 'isLocked',
    createdBy: 'createdBy',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const ForecastSeriesScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    scenarioId: 'scenarioId',
    name: 'name',
    direction: 'direction',
    categoryId: 'categoryId',
    companyId: 'companyId',
    preferredAccountId: 'preferredAccountId',
    baseAmount: 'baseAmount',
    freq: 'freq',
    interval: 'interval',
    dayOfMonth: 'dayOfMonth',
    weekday: 'weekday',
    weekOfMonth: 'weekOfMonth',
    monthOfYear: 'monthOfYear',
    policy: 'policy',
    startDate: 'startDate',
    endDate: 'endDate',
    isActive: 'isActive',
    notes: 'notes',
    numberOfPayments: 'numberOfPayments',
    jetHrEmployeeUuid: 'jetHrEmployeeUuid',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const ForecastOccurrenceScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    scenarioId: 'scenarioId',
    seriesId: 'seriesId',
    name: 'name',
    direction: 'direction',
    scheduledDate: 'scheduledDate',
    status: 'status',
    reconciliationStatus: 'reconciliationStatus',
    cashReconciliationStatus: 'cashReconciliationStatus',
    expectedAmount: 'expectedAmount',
    overrideAmount: 'overrideAmount',
    actualAmount: 'actualAmount',
    varianceAmount: 'varianceAmount',
    cashRealizedAmount: 'cashRealizedAmount',
    cashVarianceAmount: 'cashVarianceAmount',
    varianceReason: 'varianceReason',
    documentId: 'documentId',
    companyId: 'companyId',
    categoryId: 'categoryId',
    accountId: 'accountId',
    description: 'description',
    isUserModified: 'isUserModified',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const ForecastPaymentScheduleScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    forecastOccurrenceId: 'forecastOccurrenceId',
    installmentNumber: 'installmentNumber',
    scheduledDate: 'scheduledDate',
    expectedAmount: 'expectedAmount',
    reconciliationStatus: 'reconciliationStatus',
    cashReconciliationStatus: 'cashReconciliationStatus',
    cashRealizedAmount: 'cashRealizedAmount',
    cashVarianceAmount: 'cashVarianceAmount',
    description: 'description',
    cashMovementId: 'cashMovementId',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const ReconciliationLinkScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    forecastOccurrenceId: 'forecastOccurrenceId',
    forecastPaymentScheduleId: 'forecastPaymentScheduleId',
    documentId: 'documentId',
    documentPaymentScheduleId: 'documentPaymentScheduleId',
    cashMovementAllocationId: 'cashMovementAllocationId',
    reconciliationType: 'reconciliationType',
    linkStatus: 'linkStatus',
    matchQuality: 'matchQuality',
    companyMatchScore: 'companyMatchScore',
    documentNumberMatchScore: 'documentNumberMatchScore',
    isAutomatic: 'isAutomatic',
    proposalGroup: 'proposalGroup',
    dateVarianceDays: 'dateVarianceDays',
    amountVariance: 'amountVariance',
    amountVariancePercentage: 'amountVariancePercentage',
    notes: 'notes',
    reconciledBy: 'reconciledBy',
    reconciledAt: 'reconciledAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const ForecastAccountHistoryEventScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    accountId: 'accountId',
    actorUserId: 'actorUserId',
    before: 'before',
    after: 'after',
    createdAt: 'createdAt'
};
export const ForeignInvoiceAnalysisScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    targetMonth: 'targetMonth',
    status: 'status',
    summary: 'summary',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const ForeignInvoiceSourceDocumentScalarFieldEnum = {
    id: 'id',
    analysisId: 'analysisId',
    tenantId: 'tenantId',
    fileName: 'fileName',
    mimeType: 'mimeType',
    ocrData: 'ocrData',
    overallConfidence: 'overallConfidence',
    issueDate: 'issueDate',
    totalAmount: 'totalAmount',
    currency: 'currency',
    eurEquivalentAmount: 'eurEquivalentAmount',
    fxRateToEur: 'fxRateToEur',
    fxRateDate: 'fxRateDate',
    fxRateProvider: 'fxRateProvider',
    counterpartyName: 'counterpartyName',
    counterpartyVatNumber: 'counterpartyVatNumber',
    invoiceNumber: 'invoiceNumber',
    suggestedElectronicType: 'suggestedElectronicType',
    pdfContent: 'pdfContent',
    createdAt: 'createdAt'
};
export const ForeignInvoiceMovementMatchScalarFieldEnum = {
    id: 'id',
    analysisId: 'analysisId',
    tenantId: 'tenantId',
    cashMovementId: 'cashMovementId',
    sourceDocumentId: 'sourceDocumentId',
    status: 'status',
    matchScore: 'matchScore',
    reason: 'reason',
    suggestedElectronicType: 'suggestedElectronicType',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const ForeignInvoiceVendorAliasScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    scopeKey: 'scopeKey',
    aliasText: 'aliasText',
    canonicalVendor: 'canonicalVendor',
    source: 'source',
    confidence: 'confidence',
    usageCount: 'usageCount',
    successCount: 'successCount',
    failureCount: 'failureCount',
    isActive: 'isActive',
    isSeeded: 'isSeeded',
    isExcluded: 'isExcluded',
    defaultElectronicType: 'defaultElectronicType',
    lastMatchedAt: 'lastMatchedAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const HotelReservationScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    forecastOccurrenceId: 'forecastOccurrenceId',
    reference: 'reference',
    guestName: 'guestName',
    companyId: 'companyId',
    checkIn: 'checkIn',
    checkOut: 'checkOut',
    status: 'status',
    notes: 'notes',
    archivedAt: 'archivedAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const InfrastructureContractScalarFieldEnum = {
    id: 'id',
    supplierName: 'supplierName',
    title: 'title',
    fileName: 'fileName',
    pdfPath: 'pdfPath',
    startsAt: 'startsAt',
    endsAt: 'endsAt',
    notes: 'notes',
    active: 'active',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const InfrastructureCostItemScalarFieldEnum = {
    id: 'id',
    contractId: 'contractId',
    name: 'name',
    unit: 'unit',
    billingFrequency: 'billingFrequency',
    fixedFee: 'fixedFee',
    unitPrice: 'unitPrice',
    includedUnits: 'includedUnits',
    expectedMonthlyVolume: 'expectedMonthlyVolume',
    minimumFee: 'minimumFee',
    contractLimit: 'contractLimit',
    contractLimitFrequency: 'contractLimitFrequency',
    currentUsage: 'currentUsage',
    warningPercent: 'warningPercent',
    notes: 'notes',
    active: 'active',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const ProfitabilitySettingsScalarFieldEnum = {
    id: 'id',
    supportMonthlyPerCustomer: 'supportMonthlyPerCustomer',
    aiMonthlyPerCustomer: 'aiMonthlyPerCustomer',
    personnelMonthlyTotal: 'personnelMonthlyTotal',
    otherMonthlyTotal: 'otherMonthlyTotal',
    onboardingCostPerContract: 'onboardingCostPerContract',
    warningPercent: 'warningPercent',
    criticalPercent: 'criticalPercent',
    alternativeOffer: 'alternativeOffer',
    updatedAt: 'updatedAt'
};
export const IntegrationConnectionScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    provider: 'provider',
    status: 'status',
    externalRef: 'externalRef',
    credentials: 'credentials',
    settings: 'settings',
    credentialsExpireAt: 'credentialsExpireAt',
    lastSyncAt: 'lastSyncAt',
    lastSyncError: 'lastSyncError',
    syncInProgress: 'syncInProgress',
    syncStartedAt: 'syncStartedAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const IntegrationWebhookEventScalarFieldEnum = {
    id: 'id',
    connectionId: 'connectionId',
    provider: 'provider',
    externalId: 'externalId',
    eventType: 'eventType',
    payload: 'payload',
    processedAt: 'processedAt',
    error: 'error',
    createdAt: 'createdAt'
};
export const ExternalDocumentLinkScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    provider: 'provider',
    documentId: 'documentId',
    externalId: 'externalId',
    direction: 'direction',
    pushState: 'pushState',
    pushedVoucherId: 'pushedVoucherId',
    pushedAmount: 'pushedAmount',
    pushedCumulativeAmount: 'pushedCumulativeAmount',
    pushIdempotencyKey: 'pushIdempotencyKey',
    pushAttempts: 'pushAttempts',
    lastPushAttemptAt: 'lastPushAttemptAt',
    lastPushedAt: 'lastPushedAt',
    lastPushError: 'lastPushError',
    appliedInboundAt: 'appliedInboundAt',
    appliedScheduleIds: 'appliedScheduleIds',
    revertedInboundAt: 'revertedInboundAt',
    lastPulledState: 'lastPulledState',
    lastPulledAt: 'lastPulledAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const ErpSyncDivergenceScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    provider: 'provider',
    type: 'type',
    status: 'status',
    dedupKey: 'dedupKey',
    documentId: 'documentId',
    externalId: 'externalId',
    linkId: 'linkId',
    details: 'details',
    firstDetectedAt: 'firstDetectedAt',
    lastDetectedAt: 'lastDetectedAt',
    acknowledgedAt: 'acknowledgedAt',
    acknowledgedBy: 'acknowledgedBy',
    resolvedAt: 'resolvedAt',
    resolution: 'resolution'
};
export const ErpSyncRunScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    provider: 'provider',
    kind: 'kind',
    trigger: 'trigger',
    startedAt: 'startedAt',
    finishedAt: 'finishedAt',
    report: 'report',
    summary: 'summary',
    error: 'error'
};
export const ErpAccountMappingScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    provider: 'provider',
    accountId: 'accountId',
    externalAccountRef: 'externalAccountRef',
    externalAccountName: 'externalAccountName',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const SupplierCatalogItemScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    provider: 'provider',
    supplierAccount: 'supplierAccount',
    externalCode: 'externalCode',
    productId: 'productId',
    supplierPrice: 'supplierPrice',
    listPrice: 'listPrice',
    immediateAvailability: 'immediateAvailability',
    futureAvailability: 'futureAvailability',
    brand: 'brand',
    category: 'category',
    lastSeenAt: 'lastSeenAt',
    isAvailable: 'isAvailable'
};
export const IntentDeclarationScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    companyId: 'companyId',
    protocolNumber: 'protocolNumber',
    protocolDate: 'protocolDate',
    year: 'year',
    kind: 'kind',
    amount: 'amount',
    status: 'status',
    notes: 'notes',
    verifiedAt: 'verifiedAt',
    verifiedByUserId: 'verifiedByUserId',
    previousDeclarationId: 'previousDeclarationId',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const InvoicingSdiTransitionScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    contractId: 'contractId',
    confirmedBy: 'confirmedBy',
    confirmedFrom: 'confirmedFrom',
    confirmedAt: 'confirmedAt',
    status: 'status',
    attempts: 'attempts',
    nextAttemptAt: 'nextAttemptAt',
    lastErrorCode: 'lastErrorCode',
    customerWasEnabled: 'customerWasEnabled',
    supplierWasEnabled: 'supplierWasEnabled',
    drawerWasEnabled: 'drawerWasEnabled',
    drawerAutoRenewWasEnabled: 'drawerAutoRenewWasEnabled',
    completedAt: 'completedAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const KnowledgeSourceScalarFieldEnum = {
    id: 'id',
    code: 'code',
    name: 'name',
    isActive: 'isActive',
    priority: 'priority',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const KnowledgeDocumentScalarFieldEnum = {
    id: 'id',
    sourceId: 'sourceId',
    externalId: 'externalId',
    slug: 'slug',
    title: 'title',
    summary: 'summary',
    bodyMarkdown: 'bodyMarkdown',
    bodyPlainText: 'bodyPlainText',
    category: 'category',
    documentType: 'documentType',
    language: 'language',
    articlePath: 'articlePath',
    articleSlug: 'articleSlug',
    status: 'status',
    lastReviewedAt: 'lastReviewedAt',
    contentHash: 'contentHash',
    metadata: 'metadata',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const KnowledgeChunkScalarFieldEnum = {
    id: 'id',
    documentId: 'documentId',
    chunkIndex: 'chunkIndex',
    chunkType: 'chunkType',
    heading: 'heading',
    anchor: 'anchor',
    text: 'text',
    retrievalText: 'retrievalText',
    tokenCount: 'tokenCount',
    weight: 'weight',
    metadata: 'metadata',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const KnowledgeDocumentEmbeddingScalarFieldEnum = {
    id: 'id',
    documentId: 'documentId',
    model: 'model',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const KnowledgeChunkEmbeddingScalarFieldEnum = {
    id: 'id',
    chunkId: 'chunkId',
    model: 'model',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const KnowledgeIngestionRunScalarFieldEnum = {
    id: 'id',
    sourceId: 'sourceId',
    status: 'status',
    startedAt: 'startedAt',
    completedAt: 'completedAt',
    documentsProcessed: 'documentsProcessed',
    documentsCreated: 'documentsCreated',
    documentsUpdated: 'documentsUpdated',
    documentsRemoved: 'documentsRemoved',
    errorLog: 'errorLog',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const McpAuditLogScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    eventType: 'eventType',
    occurredAt: 'occurredAt',
    clientId: 'clientId',
    userId: 'userId',
    tokenId: 'tokenId',
    toolName: 'toolName',
    outcome: 'outcome',
    description: 'description',
    metadata: 'metadata',
    ipAddress: 'ipAddress',
    userAgent: 'userAgent',
    createdAt: 'createdAt'
};
export const McpClientScalarFieldEnum = {
    id: 'id',
    clientName: 'clientName',
    clientSecretHash: 'clientSecretHash',
    isPublic: 'isPublic',
    redirectUris: 'redirectUris',
    grantTypes: 'grantTypes',
    responseTypes: 'responseTypes',
    tokenEndpointAuthMethod: 'tokenEndpointAuthMethod',
    scope: 'scope',
    softwareId: 'softwareId',
    softwareVersion: 'softwareVersion',
    clientUri: 'clientUri',
    logoUri: 'logoUri',
    contacts: 'contacts',
    registrationAccessTokenHash: 'registrationAccessTokenHash',
    verified: 'verified',
    isActive: 'isActive',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    lastUsedAt: 'lastUsedAt'
};
export const McpAuthorizationCodeScalarFieldEnum = {
    id: 'id',
    codeHash: 'codeHash',
    clientId: 'clientId',
    userId: 'userId',
    tenantId: 'tenantId',
    tenantUserId: 'tenantUserId',
    codeChallenge: 'codeChallenge',
    codeChallengeMethod: 'codeChallengeMethod',
    redirectUri: 'redirectUri',
    audience: 'audience',
    state: 'state',
    scope: 'scope',
    expiresAt: 'expiresAt',
    consumedAt: 'consumedAt',
    createdAt: 'createdAt'
};
export const McpTokenScalarFieldEnum = {
    id: 'id',
    kind: 'kind',
    tokenHash: 'tokenHash',
    clientId: 'clientId',
    userId: 'userId',
    tenantId: 'tenantId',
    tenantUserId: 'tenantUserId',
    parentTokenId: 'parentTokenId',
    audience: 'audience',
    status: 'status',
    scopes: 'scopes',
    issuedAt: 'issuedAt',
    expiresAt: 'expiresAt',
    lastUsedAt: 'lastUsedAt',
    revokedAt: 'revokedAt',
    revokedReason: 'revokedReason',
    ipAddress: 'ipAddress',
    userAgent: 'userAgent',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const MovementSuggestionIndexScalarFieldEnum = {
    tenantId: 'tenantId',
    movementIds: 'movementIds',
    requestedVersion: 'requestedVersion',
    completedVersion: 'completedVersion',
    buildingVersion: 'buildingVersion',
    scanCursor: 'scanCursor',
    stagedMovementIds: 'stagedMovementIds',
    owner: 'owner',
    leaseUntil: 'leaseUntil',
    nextRunAt: 'nextRunAt',
    completedAt: 'completedAt',
    attempts: 'attempts',
    lastError: 'lastError'
};
export const NotificationScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    userId: 'userId',
    type: 'type',
    title: 'title',
    message: 'message',
    data: 'data',
    isRead: 'isRead',
    readAt: 'readAt',
    createdAt: 'createdAt'
};
export const NumberingSequenceScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    acubeId: 'acubeId',
    name: 'name',
    format: 'format',
    isDefault: 'isDefault',
    isActive: 'isActive',
    documentTipo: 'documentTipo',
    documentType: 'documentType',
    lastKnownCounter: 'lastKnownCounter',
    lastKnownCounterYear: 'lastKnownCounterYear',
    countersByYear: 'countersByYear',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const PaymentDueReminderDeliveryScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    documentId: 'documentId',
    scheduleId: 'scheduleId',
    installmentNumber: 'installmentNumber',
    dueDate: 'dueDate',
    status: 'status',
    sentAt: 'sentAt',
    lastError: 'lastError',
    createdAt: 'createdAt'
};
export const PaymentTermScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    code: 'code',
    name: 'name',
    description: 'description',
    type: 'type',
    installmentRules: 'installmentRules',
    isActive: 'isActive',
    isDefault: 'isDefault',
    isSystemDefined: 'isSystemDefined',
    sortOrder: 'sortOrder',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const PaymentScheduleTemplateScalarFieldEnum = {
    id: 'id',
    seriesId: 'seriesId',
    installmentNumber: 'installmentNumber',
    percentageOfTotal: 'percentageOfTotal',
    startOfMonth: 'startOfMonth',
    endOfMonth: 'endOfMonth',
    dayOffset: 'dayOffset',
    description: 'description',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const VatRateScalarFieldEnum = {
    id: 'id',
    rate: 'rate',
    nature: 'nature',
    code: 'code',
    description: 'description',
    descriptionEn: 'descriptionEn',
    countryCode: 'countryCode',
    category: 'category',
    validFrom: 'validFrom',
    validTo: 'validTo',
    isSystemDefined: 'isSystemDefined',
    notes: 'notes',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const StripeTransactionsScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const AccountGroupScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    provider: 'provider',
    providerConnectionId: 'providerConnectionId',
    name: 'name',
    linkedBankAccountId: 'linkedBankAccountId',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const PaypalFundingScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    internalTransferId: 'internalTransferId',
    purchaseMovementId: 'purchaseMovementId',
    fundingMovementId: 'fundingMovementId',
    origin: 'origin',
    reconstructionReason: 'reconstructionReason',
    previousFundingState: 'previousFundingState',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const PaypalFundingEventScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    fundingId: 'fundingId',
    action: 'action',
    actorId: 'actorId',
    data: 'data',
    createdAt: 'createdAt'
};
export const PaypalFundingImportReviewScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    accountId: 'accountId',
    importSource: 'importSource',
    externalId: 'externalId',
    status: 'status',
    reason: 'reason',
    payload: 'payload',
    candidateFundingIds: 'candidateFundingIds',
    createdAt: 'createdAt',
    resolvedAt: 'resolvedAt'
};
export const PersonnelCostPeriodScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    employeeId: 'employeeId',
    technicianId: 'technicianId',
    month: 'month',
    kind: 'kind',
    totalCents: 'totalCents',
    referenceMinutes: 'referenceMinutes',
    mode: 'mode',
    source: 'source',
    version: 'version',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const PersonnelCostAllocationScalarFieldEnum = {
    id: 'id',
    periodId: 'periodId',
    commessaId: 'commessaId',
    value: 'value',
    amountCents: 'amountCents',
    sessions: 'sessions'
};
export const PersonnelCostDocumentScalarFieldEnum = {
    id: 'id',
    periodId: 'periodId',
    documentId: 'documentId',
    extraCents: 'extraCents',
    createdAt: 'createdAt'
};
export const PersonnelCostEventScalarFieldEnum = {
    id: 'id',
    periodId: 'periodId',
    actorId: 'actorId',
    version: 'version',
    snapshot: 'snapshot',
    createdAt: 'createdAt'
};
export const PlanScalarFieldEnum = {
    id: 'id',
    code: 'code',
    name: 'name',
    description: 'description',
    revenueFrom: 'revenueFrom',
    revenueTo: 'revenueTo',
    accountsLimit: 'accountsLimit',
    aiTokenLimit: 'aiTokenLimit',
    invoiceMonthlyLimit: 'invoiceMonthlyLimit',
    invoiceAnnualLimit: 'invoiceAnnualLimit',
    bankEntityLimit: 'bankEntityLimit',
    taxDrawerLimit: 'taxDrawerLimit',
    taxDrawerDocumentMonthlyLimit: 'taxDrawerDocumentMonthlyLimit',
    taxDrawerDocumentAnnualLimit: 'taxDrawerDocumentAnnualLimit',
    f24AnnualLimit: 'f24AnnualLimit',
    userLimit: 'userLimit',
    extraUserMonthlyPrice: 'extraUserMonthlyPrice',
    extraBankMonthlyPrice: 'extraBankMonthlyPrice',
    extraTaxDrawerMonthlyPrice: 'extraTaxDrawerMonthlyPrice',
    technicianLimit: 'technicianLimit',
    extraTechnicianMonthlyPrice: 'extraTechnicianMonthlyPrice',
    warehouseLimit: 'warehouseLimit',
    extraWarehouseMonthlyPrice: 'extraWarehouseMonthlyPrice',
    includedModules: 'includedModules',
    availableAddons: 'availableAddons',
    esdiConnectionLimit: 'esdiConnectionLimit',
    targetGrossMargin: 'targetGrossMargin',
    tier: 'tier',
    price: 'price',
    monthlyPrice: 'monthlyPrice',
    originalPrice: 'originalPrice',
    onboardingFee: 'onboardingFee',
    active: 'active',
    isStartup: 'isStartup',
    features: 'features',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const PriceListScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    code: 'code',
    name: 'name',
    description: 'description',
    companyId: 'companyId',
    categoryId: 'categoryId',
    validFrom: 'validFrom',
    validTo: 'validTo',
    priority: 'priority',
    isActive: 'isActive',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const PriceListItemScalarFieldEnum = {
    id: 'id',
    priceListId: 'priceListId',
    productId: 'productId',
    basePrice: 'basePrice',
    discountPercent: 'discountPercent',
    unitOfMeasure: 'unitOfMeasure',
    notes: 'notes',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const PriceListTierScalarFieldEnum = {
    id: 'id',
    itemId: 'itemId',
    minQuantity: 'minQuantity',
    maxQuantity: 'maxQuantity',
    price: 'price',
    discountPercent: 'discountPercent',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const PriceListRuleScalarFieldEnum = {
    id: 'id',
    priceListId: 'priceListId',
    type: 'type',
    targetId: 'targetId',
    modifierType: 'modifierType',
    modifierValue: 'modifierValue',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const ProductReleaseScalarFieldEnum = {
    id: 'id',
    version: 'version',
    commitSha: 'commitSha',
    environment: 'environment',
    status: 'status',
    deployedAt: 'deployedAt',
    publishedAt: 'publishedAt',
    slackStatus: 'slackStatus',
    slackAttemptedAt: 'slackAttemptedAt',
    slackPublishedAt: 'slackPublishedAt',
    slackError: 'slackError',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const ProductReleaseContributorScalarFieldEnum = {
    id: 'id',
    releaseId: 'releaseId',
    name: 'name',
    email: 'email',
    commitCount: 'commitCount'
};
export const ProductChangeScalarFieldEnum = {
    id: 'id',
    releaseId: 'releaseId',
    sourcePath: 'sourcePath',
    type: 'type',
    area: 'area',
    title: 'title',
    description: 'description',
    visibility: 'visibility',
    ticket: 'ticket',
    prNumber: 'prNumber',
    createdAt: 'createdAt'
};
export const ProductScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    code: 'code',
    manualCode: 'manualCode',
    barcode: 'barcode',
    producerCode: 'producerCode',
    producerName: 'producerName',
    description: 'description',
    extendedDescription: 'extendedDescription',
    productType: 'productType',
    productSubtype: 'productSubtype',
    categoryId: 'categoryId',
    category2Id: 'category2Id',
    customField1: 'customField1',
    customField2: 'customField2',
    defaultRevenueCategoryId: 'defaultRevenueCategoryId',
    defaultUnitOfMeasure: 'defaultUnitOfMeasure',
    defaultUnitPrice: 'defaultUnitPrice',
    defaultUnitPriceVat: 'defaultUnitPriceVat',
    defaultVatRateId: 'defaultVatRateId',
    defaultVatNature: 'defaultVatNature',
    isActive: 'isActive',
    isObsolete: 'isObsolete',
    isHidden: 'isHidden',
    notes: 'notes',
    internalNote: 'internalNote',
    warehouseLocation: 'warehouseLocation',
    inventoryEnabled: 'inventoryEnabled',
    minimumStock: 'minimumStock',
    reorderPoint: 'reorderPoint',
    safetyStock: 'safetyStock',
    reorderQuantity: 'reorderQuantity',
    otherData: 'otherData',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const PublicApiKeyScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    name: 'name',
    keyHash: 'keyHash',
    keyPrefix: 'keyPrefix',
    lastFour: 'lastFour',
    scopes: 'scopes',
    status: 'status',
    expiresAt: 'expiresAt',
    lastUsedAt: 'lastUsedAt',
    createdByUserId: 'createdByUserId',
    revokedAt: 'revokedAt',
    revokedReason: 'revokedReason',
    allowedCidrs: 'allowedCidrs',
    paymentExecutionEnabled: 'paymentExecutionEnabled',
    paymentApprovedAt: 'paymentApprovedAt',
    paymentApprovedByUserId: 'paymentApprovedByUserId',
    maxPaymentAmount: 'maxPaymentAmount',
    dailyPaymentLimit: 'dailyPaymentLimit',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const PublicApiPaymentExecutionScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    apiKeyId: 'apiKeyId',
    accountId: 'accountId',
    operation: 'operation',
    amount: 'amount',
    currency: 'currency',
    status: 'status',
    externalPaymentId: 'externalPaymentId',
    failureCode: 'failureCode',
    completedAt: 'completedAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const PublicApiExternalReferenceScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    resourceType: 'resourceType',
    resourceId: 'resourceId',
    system: 'system',
    externalId: 'externalId',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const PublicApiJobScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    apiKeyId: 'apiKeyId',
    type: 'type',
    status: 'status',
    progress: 'progress',
    request: 'request',
    result: 'result',
    errorCode: 'errorCode',
    errorMessage: 'errorMessage',
    startedAt: 'startedAt',
    completedAt: 'completedAt',
    expiresAt: 'expiresAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const PublicApiIdempotencyKeyScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    apiKeyId: 'apiKeyId',
    route: 'route',
    idempotencyKey: 'idempotencyKey',
    requestHash: 'requestHash',
    status: 'status',
    responseStatus: 'responseStatus',
    responseBody: 'responseBody',
    expiresAt: 'expiresAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const PublicApiAuditLogScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    apiKeyId: 'apiKeyId',
    operation: 'operation',
    resource: 'resource',
    outcome: 'outcome',
    statusCode: 'statusCode',
    requestId: 'requestId',
    ipAddress: 'ipAddress',
    userAgent: 'userAgent',
    durationMs: 'durationMs',
    occurredAt: 'occurredAt'
};
export const PublicApiEventScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    resourceType: 'resourceType',
    resourceId: 'resourceId',
    action: 'action',
    occurredAt: 'occurredAt',
    metadata: 'metadata',
    dedupeKey: 'dedupeKey',
    createdAt: 'createdAt'
};
export const PublicApiScanCheckpointScalarFieldEnum = {
    resourceType: 'resourceType',
    cursor: 'cursor',
    cursorId: 'cursorId',
    updatedAt: 'updatedAt'
};
export const PublicApiWebhookScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    name: 'name',
    url: 'url',
    eventTypes: 'eventTypes',
    secretCiphertext: 'secretCiphertext',
    secretPrefix: 'secretPrefix',
    status: 'status',
    consecutiveFailures: 'consecutiveFailures',
    terminalFailureCount: 'terminalFailureCount',
    lastDeliveredAt: 'lastDeliveredAt',
    lastFailedAt: 'lastFailedAt',
    disabledAt: 'disabledAt',
    createdByUserId: 'createdByUserId',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const PublicApiWebhookDeliveryScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    webhookId: 'webhookId',
    eventId: 'eventId',
    status: 'status',
    attemptCount: 'attemptCount',
    nextAttemptAt: 'nextAttemptAt',
    responseStatus: 'responseStatus',
    errorMessage: 'errorMessage',
    deliveredAt: 'deliveredAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const RecurringInvoiceTemplateScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    sourceDocumentId: 'sourceDocumentId',
    name: 'name',
    frequency: 'frequency',
    isActive: 'isActive',
    nextRunDate: 'nextRunDate',
    endDate: 'endDate',
    lastRunAt: 'lastRunAt',
    generatedCount: 'generatedCount',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const ReferrerScalarFieldEnum = {
    id: 'id',
    userId: 'userId',
    referralCode: 'referralCode',
    type: 'type',
    parentId: 'parentId',
    name: 'name',
    email: 'email',
    phone: 'phone',
    vatId: 'vatId',
    fiscalCode: 'fiscalCode',
    address: 'address',
    firstPurchasePercentage: 'firstPurchasePercentage',
    renewalPercentage: 'renewalPercentage',
    activationPercentage: 'activationPercentage',
    renewalDurationMonths: 'renewalDurationMonths',
    commissionSchedule: 'commissionSchedule',
    parentCommissionTerms: 'parentCommissionTerms',
    isActive: 'isActive',
    deactivatedAt: 'deactivatedAt',
    deactivationReason: 'deactivationReason',
    notes: 'notes',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const ReferrerInvitationScalarFieldEnum = {
    id: 'id',
    referrerId: 'referrerId',
    email: 'email',
    token: 'token',
    expiresAt: 'expiresAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const TenantReferralScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    referrerId: 'referrerId',
    referredAt: 'referredAt',
    activationPercentage: 'activationPercentage',
    parentActivationPercentage: 'parentActivationPercentage',
    subscriptionPercentage: 'subscriptionPercentage',
    parentSubscriptionPercentage: 'parentSubscriptionPercentage'
};
export const CommissionScalarFieldEnum = {
    id: 'id',
    referrerId: 'referrerId',
    tenantReferralId: 'tenantReferralId',
    tenantPaymentId: 'tenantPaymentId',
    accrualKey: 'accrualKey',
    receiptDate: 'receiptDate',
    receiptSource: 'receiptSource',
    baseAmount: 'baseAmount',
    percentage: 'percentage',
    commissionAmount: 'commissionAmount',
    isFirstPurchase: 'isFirstPurchase',
    activationBaseAmount: 'activationBaseAmount',
    activationPercentage: 'activationPercentage',
    activationCommissionAmount: 'activationCommissionAmount',
    activationBreakdown: 'activationBreakdown',
    status: 'status',
    approvedAt: 'approvedAt',
    approvedById: 'approvedById',
    paidAt: 'paidAt',
    paidById: 'paidById',
    cancelledAt: 'cancelledAt',
    cancelledById: 'cancelledById',
    cancellationReason: 'cancellationReason',
    notes: 'notes',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const TenantActivationChargeScalarFieldEnum = {
    tenantId: 'tenantId',
    tenantPaymentId: 'tenantPaymentId',
    amount: 'amount'
};
export const CommissionReceiptRecognitionScalarFieldEnum = {
    id: 'id',
    issuerTenantId: 'issuerTenantId',
    payerTenantId: 'payerTenantId',
    invoiceId: 'invoiceId',
    cashMovementId: 'cashMovementId',
    paymentDate: 'paymentDate',
    snapshot: 'snapshot',
    createdAt: 'createdAt'
};
export const CountryScalarFieldEnum = {
    id: 'id',
    alpha2: 'alpha2',
    alpha3: 'alpha3',
    name: 'name'
};
export const ProvinceScalarFieldEnum = {
    id: 'id',
    code: 'code',
    name: 'name'
};
export const MunicipalityScalarFieldEnum = {
    id: 'id',
    cap: 'cap',
    provinceCode: 'provinceCode',
    name: 'name',
    codiceIstat: 'codiceIstat',
    codiceBelfiore: 'codiceBelfiore',
    provinceId: 'provinceId'
};
export const MunicipalityValidityScalarFieldEnum = {
    id: 'id',
    sourceKey: 'sourceKey',
    codiceBelfiore: 'codiceBelfiore',
    codiceIstat: 'codiceIstat',
    name: 'name',
    normalizedName: 'normalizedName',
    provinceCode: 'provinceCode',
    validFromRaw: 'validFromRaw',
    validToRaw: 'validToRaw',
    isActive: 'isActive'
};
export const MunicipalityTransitionScalarFieldEnum = {
    id: 'id',
    sourceBelfiore: 'sourceBelfiore',
    targetBelfiore: 'targetBelfiore',
    reason: 'reason',
    description: 'description'
};
export const SyncRunScalarFieldEnum = {
    id: 'id',
    type: 'type',
    status: 'status',
    tenantId: 'tenantId',
    userId: 'userId',
    startedAt: 'startedAt',
    endedAt: 'endedAt',
    totalTenants: 'totalTenants',
    successfulTenants: 'successfulTenants',
    failedTenants: 'failedTenants',
    accountsSynced: 'accountsSynced',
    transactionsSynced: 'transactionsSynced',
    documentsSynced: 'documentsSynced',
    duplicatesFound: 'duplicatesFound',
    reconciliationProcessed: 'reconciliationProcessed',
    reconciliationProposed: 'reconciliationProposed',
    durationMs: 'durationMs',
    metadata: 'metadata',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const ServiceUsageMonthlyScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    serviceType: 'serviceType',
    year: 'year',
    month: 'month',
    count: 'count',
    updatedAt: 'updatedAt'
};
export const SepaPaymentScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    externalPaymentId: 'externalPaymentId',
    status: 'status',
    date: 'date',
    errorMessage: 'errorMessage',
    failedAt: 'failedAt',
    failureReasonCode: 'failureReasonCode',
    accountId: 'accountId',
    description: 'description',
    statusManuallySet: 'statusManuallySet',
    amount: 'amount',
    companyId: 'companyId',
    creditorIban: 'creditorIban',
    creditorName: 'creditorName',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const ServiceContractScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    companyId: 'companyId',
    code: 'code',
    name: 'name',
    status: 'status',
    autoRenew: 'autoRenew',
    billingProfile: 'billingProfile',
    notes: 'notes',
    version: 'version',
    lastAutoRenewalAt: 'lastAutoRenewalAt',
    lastAutoRenewalError: 'lastAutoRenewalError',
    sourceRecurringTemplateId: 'sourceRecurringTemplateId',
    createdById: 'createdById',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const ServiceContractPeriodScalarFieldEnum = {
    id: 'id',
    contractId: 'contractId',
    sequence: 'sequence',
    startDate: 'startDate',
    endDate: 'endDate',
    status: 'status',
    alreadyInvoiced: 'alreadyInvoiced',
    commessaId: 'commessaId',
    createdAt: 'createdAt'
};
export const ServiceContractLineScalarFieldEnum = {
    billingKey: 'billingKey',
    billingFrequency: 'billingFrequency',
    id: 'id',
    periodId: 'periodId',
    previousLineId: 'previousLineId',
    productId: 'productId',
    description: 'description',
    baseQuantity: 'baseQuantity',
    unitAnnualPrice: 'unitAnnualPrice',
    vatRateId: 'vatRateId',
    sortOrder: 'sortOrder'
};
export const ServiceContractChangeScalarFieldEnum = {
    id: 'id',
    contractId: 'contractId',
    lineId: 'lineId',
    kind: 'kind',
    quantity: 'quantity',
    effectiveDate: 'effectiveDate',
    status: 'status',
    requestKey: 'requestKey',
    createdById: 'createdById',
    createdAt: 'createdAt'
};
export const BillableChargeScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    companyId: 'companyId',
    contractId: 'contractId',
    periodId: 'periodId',
    lineId: 'lineId',
    changeId: 'changeId',
    workReportId: 'workReportId',
    workReportSessionId: 'workReportSessionId',
    workReportLineId: 'workReportLineId',
    source: 'source',
    originKey: 'originKey',
    description: 'description',
    quantity: 'quantity',
    unitAnnualPrice: 'unitAnnualPrice',
    months: 'months',
    unitPrice: 'unitPrice',
    productId: 'productId',
    amount: 'amount',
    vatRateId: 'vatRateId',
    effectiveDate: 'effectiveDate',
    competenceStartDate: 'competenceStartDate',
    competenceEndDate: 'competenceEndDate',
    status: 'status',
    documentId: 'documentId',
    documentLineNumber: 'documentLineNumber',
    invoicedAt: 'invoicedAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const ServiceContractEventScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    contractId: 'contractId',
    type: 'type',
    version: 'version',
    payload: 'payload',
    actorUserId: 'actorUserId',
    createdAt: 'createdAt'
};
export const WarehouseScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    code: 'code',
    name: 'name',
    isDefault: 'isDefault',
    isActive: 'isActive',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const WarehouseLocationScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    warehouseId: 'warehouseId',
    code: 'code',
    name: 'name',
    isDefault: 'isDefault',
    isActive: 'isActive',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const StockBalanceScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    productId: 'productId',
    warehouseId: 'warehouseId',
    locationId: 'locationId',
    quantityOnHand: 'quantityOnHand',
    quantityReserved: 'quantityReserved',
    averageUnitCost: 'averageUnitCost',
    totalStockValue: 'totalStockValue',
    updatedAt: 'updatedAt'
};
export const StockMovementScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    productId: 'productId',
    warehouseId: 'warehouseId',
    locationId: 'locationId',
    documentId: 'documentId',
    documentLineId: 'documentLineId',
    sourceMovementId: 'sourceMovementId',
    idempotencyKey: 'idempotencyKey',
    movementType: 'movementType',
    direction: 'direction',
    quantity: 'quantity',
    unitOfMeasure: 'unitOfMeasure',
    unitCost: 'unitCost',
    occurredAt: 'occurredAt',
    reason: 'reason',
    note: 'note',
    createdById: 'createdById',
    createdAt: 'createdAt'
};
export const InventorySessionScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    warehouseId: 'warehouseId',
    code: 'code',
    status: 'status',
    reference: 'reference',
    scheduledDate: 'scheduledDate',
    startedAt: 'startedAt',
    closedAt: 'closedAt',
    createdById: 'createdById',
    closedById: 'closedById',
    notes: 'notes',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const InventorySessionLineScalarFieldEnum = {
    id: 'id',
    sessionId: 'sessionId',
    productId: 'productId',
    locationId: 'locationId',
    expectedQty: 'expectedQty',
    countedQty: 'countedQty',
    diff: 'diff',
    unitCost: 'unitCost',
    note: 'note',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const SubscriptionEmailNotificationScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    type: 'type',
    sentAt: 'sentAt',
    sentById: 'sentById',
    tenantPlanHistoryId: 'tenantPlanHistoryId',
    sourceDocumentId: 'sourceDocumentId'
};
export const SubscriptionPaymentBlockWaiverScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    documentId: 'documentId',
    waivedAt: 'waivedAt',
    waivedById: 'waivedById'
};
export const SupportTicketScalarFieldEnum = {
    id: 'id',
    number: 'number',
    tenantId: 'tenantId',
    createdById: 'createdById',
    contactEmail: 'contactEmail',
    contactName: 'contactName',
    contactPhone: 'contactPhone',
    subject: 'subject',
    description: 'description',
    type: 'type',
    category: 'category',
    status: 'status',
    priority: 'priority',
    assignedToId: 'assignedToId',
    assignedAt: 'assignedAt',
    firstResponseAt: 'firstResponseAt',
    resolvedAt: 'resolvedAt',
    closedAt: 'closedAt',
    lastCustomerMessageAt: 'lastCustomerMessageAt',
    lastOperatorMessageAt: 'lastOperatorMessageAt',
    reopenCount: 'reopenCount',
    diagnosticContext: 'diagnosticContext',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const SupportTicketMessageScalarFieldEnum = {
    id: 'id',
    ticketId: 'ticketId',
    tenantId: 'tenantId',
    authorSide: 'authorSide',
    authorUserId: 'authorUserId',
    authorName: 'authorName',
    body: 'body',
    isInternal: 'isInternal',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const SupportTicketAttachmentScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    ticketId: 'ticketId',
    messageId: 'messageId',
    fileName: 'fileName',
    contentType: 'contentType',
    size: 'size',
    gcsBucket: 'gcsBucket',
    gcsPath: 'gcsPath',
    uploadedById: 'uploadedById',
    createdAt: 'createdAt'
};
export const SupportTicketEventScalarFieldEnum = {
    id: 'id',
    ticketId: 'ticketId',
    tenantId: 'tenantId',
    type: 'type',
    actorSide: 'actorSide',
    actorUserId: 'actorUserId',
    actorName: 'actorName',
    fromStatus: 'fromStatus',
    toStatus: 'toStatus',
    metadata: 'metadata',
    createdAt: 'createdAt'
};
export const SystemConfigScalarFieldEnum = {
    id: 'id',
    adeDelegateCredentialsUpdatedAt: 'adeDelegateCredentialsUpdatedAt',
    locationDatasetVersion: 'locationDatasetVersion',
    locationDatasetFingerprint: 'locationDatasetFingerprint',
    locationDatasetAppliedAt: 'locationDatasetAppliedAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const QueueMetricScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    queueName: 'queueName',
    waiting: 'waiting',
    active: 'active',
    completed: 'completed',
    failed: 'failed',
    delayed: 'delayed',
    paused: 'paused',
    throughputPerMinute: 'throughputPerMinute',
    avgProcessingTimeMs: 'avgProcessingTimeMs',
    successRate: 'successRate'
};
export const JobExecutionScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    jobId: 'jobId',
    jobName: 'jobName',
    queueName: 'queueName',
    status: 'status',
    startedAt: 'startedAt',
    finishedAt: 'finishedAt',
    durationMs: 'durationMs',
    inputData: 'inputData',
    outputData: 'outputData',
    errorMessage: 'errorMessage',
    stackTrace: 'stackTrace',
    attemptsMade: 'attemptsMade'
};
export const RedisMetricScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    usedMemoryBytes: 'usedMemoryBytes',
    usedMemoryPeakBytes: 'usedMemoryPeakBytes',
    connectedClients: 'connectedClients',
    uptimeInSeconds: 'uptimeInSeconds',
    opsPerSecond: 'opsPerSecond'
};
export const TenantAdditionalVatIdScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    vatId: 'vatId',
    createdAt: 'createdAt',
    createdById: 'createdById'
};
export const TenantHealthFindingScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    checkId: 'checkId',
    area: 'area',
    severity: 'severity',
    message: 'message',
    details: 'details',
    checkedAt: 'checkedAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const TenantMembershipAuditLogScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    eventType: 'eventType',
    actorUserId: 'actorUserId',
    targetUserId: 'targetUserId',
    targetEmail: 'targetEmail',
    beforeState: 'beforeState',
    afterState: 'afterState',
    metadata: 'metadata',
    occurredAt: 'occurredAt',
    createdAt: 'createdAt'
};
export const TenantStripeCustomerScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    stripeCustomerId: 'stripeCustomerId',
    createdAt: 'createdAt'
};
export const TenantScalarFieldEnum = {
    paymentOverdueSince: 'paymentOverdueSince',
    id: 'id',
    name: 'name',
    email: 'email',
    vatId: 'vatId',
    fiscalCode: 'fiscalCode',
    isActive: 'isActive',
    documentProcessingBlocked: 'documentProcessingBlocked',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    parentTenantId: 'parentTenantId',
    quotaScope: 'quotaScope',
    isDemo: 'isDemo',
    demoExpiresAt: 'demoExpiresAt',
    subscriptionEndedAt: 'subscriptionEndedAt',
    deletionScheduledAt: 'deletionScheduledAt',
    deletionRequestedAt: 'deletionRequestedAt',
    deletionReason: 'deletionReason',
    subscriptionDirectDebitEnabled: 'subscriptionDirectDebitEnabled',
    contractedInvoicingMode: 'contractedInvoicingMode',
    country: 'country',
    city: 'city',
    province: 'province',
    postalCode: 'postalCode',
    address: 'address',
    sdiCode: 'sdiCode',
    taxRegimeCode: 'taxRegimeCode',
    taxSubjectType: 'taxSubjectType',
    pec: 'pec',
    adminEmail: 'adminEmail',
    contactEmail: 'contactEmail',
    phone: 'phone',
    phone2: 'phone2',
    phone3: 'phone3',
    cassettoFiscaleCredentialExpiryDate: 'cassettoFiscaleCredentialExpiryDate',
    invoicingMode: 'invoicingMode',
    mcpAllowAllClients: 'mcpAllowAllClients',
    mcpAllowedClientProviders: 'mcpAllowedClientProviders',
    fabrickAisUserId: 'fabrickAisUserId',
    fabrickOnboardingStartedAt: 'fabrickOnboardingStartedAt',
    isDelegated: 'isDelegated',
    delegationStartDate: 'delegationStartDate',
    invoiceLastSyncAt: 'invoiceLastSyncAt',
    f24LastSyncAt: 'f24LastSyncAt',
    acubeDelegationState: 'acubeDelegationState',
    acubeDelegationProxyFiscalCode: 'acubeDelegationProxyFiscalCode',
    acubeDelegationPendingAt: 'acubeDelegationPendingAt',
    acubeBillingRegistryEnsuredAt: 'acubeBillingRegistryEnsuredAt',
    acubeBankingRegistryEnsuredAt: 'acubeBankingRegistryEnsuredAt'
};
export const TenantUserScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    userId: 'userId',
    tenantRole: 'tenantRole',
    isActive: 'isActive',
    relationshipType: 'relationshipType',
    canReadWorkReportProducts: 'canReadWorkReportProducts',
    canCreateWorkReportProducts: 'canCreateWorkReportProducts',
    canCreateWorkReportCustomers: 'canCreateWorkReportCustomers',
    canWriteWorkReportMachines: 'canWriteWorkReportMachines',
    canReadWorkReportChecks: 'canReadWorkReportChecks',
    canWriteWorkReportChecks: 'canWriteWorkReportChecks',
    canReadWorkReportAttachments: 'canReadWorkReportAttachments',
    canWriteWorkReportAttachments: 'canWriteWorkReportAttachments',
    canReadWorkReportContracts: 'canReadWorkReportContracts',
    canReadWorkReportDeliveryNotes: 'canReadWorkReportDeliveryNotes',
    canReadAllWorkReports: 'canReadAllWorkReports',
    canViewWorkReportPrices: 'canViewWorkReportPrices',
    canAccessAccounts: 'canAccessAccounts',
    canAccessForecast: 'canAccessForecast',
    canAccessDscr: 'canAccessDscr',
    canAccessDocuments: 'canAccessDocuments',
    canAccessDeliveryNotes: 'canAccessDeliveryNotes',
    canAccessOrders: 'canAccessOrders',
    canAccessAdministration: 'canAccessAdministration',
    canAccessCommesse: 'canAccessCommesse',
    canAccessServiceContracts: 'canAccessServiceContracts',
    canAccessHotel: 'canAccessHotel',
    canAccessWorkReports: 'canAccessWorkReports',
    canApproveWorkReports: 'canApproveWorkReports',
    canAccessMachines: 'canAccessMachines',
    canAccessRegistry: 'canAccessRegistry',
    canAccessProducts: 'canAccessProducts',
    canAccessWarehouse: 'canAccessWarehouse',
    canAccessPaymentSchedules: 'canAccessPaymentSchedules',
    canAccessPayments: 'canAccessPayments',
    canAccessSettings: 'canAccessSettings',
    canWrite: 'canWrite',
    canExecutePayments: 'canExecutePayments',
    canManageUsers: 'canManageUsers',
    canConnectBankAccounts: 'canConnectBankAccounts',
    canConnectCassettoFiscale: 'canConnectCassettoFiscale',
    canExport: 'canExport',
    canManageBilling: 'canManageBilling',
    canReconcile: 'canReconcile',
    canViewAccountBalances: 'canViewAccountBalances',
    canUseAI: 'canUseAI',
    canConnectMcp: 'canConnectMcp',
    canConnectJetHr: 'canConnectJetHr',
    canConnectPaypal: 'canConnectPaypal',
    canConnectReviso: 'canConnectReviso',
    canManageApiKeys: 'canManageApiKeys',
    canApproveInvoices: 'canApproveInvoices',
    canApproveMachineChecks: 'canApproveMachineChecks',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const TenantPaymentMethodScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    code: 'code',
    isDefault: 'isDefault',
    isActive: 'isActive',
    sortOrder: 'sortOrder',
    customDescription: 'customDescription',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const TenantUnitOfMeasureScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    code: 'code',
    isDefault: 'isDefault',
    isActive: 'isActive',
    sortOrder: 'sortOrder',
    customDescription: 'customDescription',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const TenantVatRateScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    vatRateId: 'vatRateId',
    isDefault: 'isDefault',
    isActive: 'isActive',
    sortOrder: 'sortOrder',
    customDescription: 'customDescription',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const TenantSettingsScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    language: 'language',
    currency: 'currency',
    timezone: 'timezone',
    timezoneOffset: 'timezoneOffset',
    timeFormat: 'timeFormat',
    dateFormat: 'dateFormat',
    weekStart: 'weekStart',
    disableAutoSendAt: 'disableAutoSendAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    automatchCash: 'automatchCash',
    automatchThreshold: 'automatchThreshold',
    automatchForecast: 'automatchForecast',
    enableAutoCategorization: 'enableAutoCategorization',
    enableAutoTransferDetection: 'enableAutoTransferDetection',
    enableAutoAccountTransferDetection: 'enableAutoAccountTransferDetection',
    enableAutoCommissionDetection: 'enableAutoCommissionDetection',
    suggestCommissionOnResidual: 'suggestCommissionOnResidual',
    dashboardCardOrder: 'dashboardCardOrder',
    hiddenDashboardCards: 'hiddenDashboardCards',
    featureFlags: 'featureFlags',
    salesStampDutyDefaults: 'salesStampDutyDefaults',
    defaultStockMovementEnabled: 'defaultStockMovementEnabled',
    allowNegativeStock: 'allowNegativeStock',
    electronicInvoiceReceiptEmailEnabled: 'electronicInvoiceReceiptEmailEnabled',
    electronicInvoiceReceiptEmails: 'electronicInvoiceReceiptEmails',
    workReportLinkEnabled: 'workReportLinkEnabled',
    workReportLinkValidityDays: 'workReportLinkValidityDays',
    workReportLinkAttachPdf: 'workReportLinkAttachPdf',
    workReportAutoPublish: 'workReportAutoPublish',
    workReportSignatureRequired: 'workReportSignatureRequired',
    machineCheckSignatureRequired: 'machineCheckSignatureRequired'
};
export const TenantPaymentScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    planId: 'planId',
    paymentDate: 'paymentDate',
    code: 'code',
    value: 'value',
    typeOfPayment: 'typeOfPayment',
    coversPeriodStart: 'coversPeriodStart',
    sourceDocumentId: 'sourceDocumentId',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const TenantPlanHistoryScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    planId: 'planId',
    tenantPaymentId: 'tenantPaymentId',
    subscriptionDate: 'subscriptionDate',
    expirationDate: 'expirationDate',
    value: 'value',
    recurringFee: 'recurringFee',
    cancelledAt: 'cancelledAt',
    cancelledById: 'cancelledById',
    billingPeriod: 'billingPeriod',
    state: 'state',
    autoRenew: 'autoRenew',
    paymentRequired: 'paymentRequired',
    paymentBlockWaivedAt: 'paymentBlockWaivedAt',
    paymentBlockWaivedById: 'paymentBlockWaivedById',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const UserScalarFieldEnum = {
    id: 'id',
    email: 'email',
    name: 'name',
    password: 'password',
    globalRole: 'globalRole',
    isEmailVerified: 'isEmailVerified',
    emailVerifiedAt: 'emailVerifiedAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    lastAccessAt: 'lastAccessAt',
    passwordChangedAt: 'passwordChangedAt',
    webLoginApprovalEnabled: 'webLoginApprovalEnabled',
    canAccessProductMcp: 'canAccessProductMcp',
    productMcpAccessVersion: 'productMcpAccessVersion'
};
export const UserTablePreferenceScalarFieldEnum = {
    id: 'id',
    userId: 'userId',
    tableKey: 'tableKey',
    columnVisibility: 'columnVisibility',
    columnSizing: 'columnSizing',
    columnPinning: 'columnPinning',
    columnOrder: 'columnOrder',
    rowDensity: 'rowDensity',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const RefreshTokenScalarFieldEnum = {
    id: 'id',
    userId: 'userId',
    refreshToken: 'refreshToken',
    expiresAt: 'expiresAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const SessionScalarFieldEnum = {
    id: 'id',
    userId: 'userId',
    tokenHash: 'tokenHash',
    scope: 'scope',
    rememberMe: 'rememberMe',
    authMethod: 'authMethod',
    isImpersonated: 'isImpersonated',
    impersonation: 'impersonation',
    permissionPreview: 'permissionPreview',
    expiresAt: 'expiresAt',
    lastUsedAt: 'lastUsedAt',
    revokedAt: 'revokedAt',
    ipAddress: 'ipAddress',
    userAgent: 'userAgent',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const CsrfTokenScalarFieldEnum = {
    id: 'id',
    sessionId: 'sessionId',
    tokenHash: 'tokenHash',
    expiresAt: 'expiresAt',
    lastUsedAt: 'lastUsedAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const PasswordResetTokenScalarFieldEnum = {
    id: 'id',
    userId: 'userId',
    token: 'token',
    expiresAt: 'expiresAt',
    usedAt: 'usedAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const EmailVerificationTokenScalarFieldEnum = {
    id: 'id',
    userId: 'userId',
    token: 'token',
    expiresAt: 'expiresAt',
    usedAt: 'usedAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const TenantInvitationScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    email: 'email',
    name: 'name',
    role: 'role',
    token: 'token',
    relationshipType: 'relationshipType',
    canReadWorkReportProducts: 'canReadWorkReportProducts',
    canCreateWorkReportProducts: 'canCreateWorkReportProducts',
    canCreateWorkReportCustomers: 'canCreateWorkReportCustomers',
    canWriteWorkReportMachines: 'canWriteWorkReportMachines',
    canReadWorkReportChecks: 'canReadWorkReportChecks',
    canWriteWorkReportChecks: 'canWriteWorkReportChecks',
    canReadWorkReportAttachments: 'canReadWorkReportAttachments',
    canWriteWorkReportAttachments: 'canWriteWorkReportAttachments',
    canReadWorkReportContracts: 'canReadWorkReportContracts',
    canReadWorkReportDeliveryNotes: 'canReadWorkReportDeliveryNotes',
    canReadAllWorkReports: 'canReadAllWorkReports',
    canViewWorkReportPrices: 'canViewWorkReportPrices',
    canAccessAccounts: 'canAccessAccounts',
    canAccessForecast: 'canAccessForecast',
    canAccessDscr: 'canAccessDscr',
    canAccessDocuments: 'canAccessDocuments',
    canAccessDeliveryNotes: 'canAccessDeliveryNotes',
    canAccessOrders: 'canAccessOrders',
    canAccessAdministration: 'canAccessAdministration',
    canAccessCommesse: 'canAccessCommesse',
    canAccessServiceContracts: 'canAccessServiceContracts',
    canAccessHotel: 'canAccessHotel',
    canAccessWorkReports: 'canAccessWorkReports',
    canApproveWorkReports: 'canApproveWorkReports',
    canAccessMachines: 'canAccessMachines',
    canAccessRegistry: 'canAccessRegistry',
    canAccessProducts: 'canAccessProducts',
    canAccessWarehouse: 'canAccessWarehouse',
    canAccessPaymentSchedules: 'canAccessPaymentSchedules',
    canAccessPayments: 'canAccessPayments',
    canAccessSettings: 'canAccessSettings',
    canWrite: 'canWrite',
    canExecutePayments: 'canExecutePayments',
    canManageUsers: 'canManageUsers',
    canConnectBankAccounts: 'canConnectBankAccounts',
    canConnectCassettoFiscale: 'canConnectCassettoFiscale',
    canExport: 'canExport',
    canManageBilling: 'canManageBilling',
    canReconcile: 'canReconcile',
    canViewAccountBalances: 'canViewAccountBalances',
    canUseAI: 'canUseAI',
    canConnectMcp: 'canConnectMcp',
    canConnectJetHr: 'canConnectJetHr',
    canConnectPaypal: 'canConnectPaypal',
    canConnectReviso: 'canConnectReviso',
    canManageApiKeys: 'canManageApiKeys',
    canApproveInvoices: 'canApproveInvoices',
    canApproveMachineChecks: 'canApproveMachineChecks',
    invitedById: 'invitedById',
    expiresAt: 'expiresAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const TrustedDeviceScalarFieldEnum = {
    id: 'id',
    userId: 'userId',
    name: 'name',
    platform: 'platform',
    installationId: 'installationId',
    secretHash: 'secretHash',
    previousSecretHash: 'previousSecretHash',
    secretRotatedAt: 'secretRotatedAt',
    retiredSecretHash: 'retiredSecretHash',
    pushToken: 'pushToken',
    pushLanguage: 'pushLanguage',
    lastUsedAt: 'lastUsedAt',
    revokedAt: 'revokedAt',
    revokedReason: 'revokedReason',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const WebLoginRequestScalarFieldEnum = {
    id: 'id',
    userId: 'userId',
    emailHash: 'emailHash',
    browserTokenHash: 'browserTokenHash',
    matchNumber: 'matchNumber',
    decoyNumbers: 'decoyNumbers',
    status: 'status',
    ipAddress: 'ipAddress',
    userAgent: 'userAgent',
    approvedByDeviceId: 'approvedByDeviceId',
    expiresAt: 'expiresAt',
    decidedAt: 'decidedAt',
    consumedAt: 'consumedAt',
    createdAt: 'createdAt'
};
export const WebAuthnCredentialScalarFieldEnum = {
    id: 'id',
    userId: 'userId',
    credentialId: 'credentialId',
    publicKey: 'publicKey',
    counter: 'counter',
    transports: 'transports',
    deviceType: 'deviceType',
    backedUp: 'backedUp',
    name: 'name',
    lastUsedAt: 'lastUsedAt',
    createdAt: 'createdAt'
};
export const WebAuthnChallengeScalarFieldEnum = {
    id: 'id',
    userId: 'userId',
    challenge: 'challenge',
    purpose: 'purpose',
    expiresAt: 'expiresAt',
    usedAt: 'usedAt',
    createdAt: 'createdAt'
};
export const ServiceTariffScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    code: 'code',
    name: 'name',
    kind: 'kind',
    hourlyRate: 'hourlyRate',
    minimumMinutes: 'minimumMinutes',
    stepMinutes: 'stepMinutes',
    vatRateId: 'vatRateId',
    productId: 'productId',
    isActive: 'isActive',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const WorkReportScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    companyId: 'companyId',
    code: 'code',
    date: 'date',
    contractId: 'contractId',
    commessaId: 'commessaId',
    location: 'location',
    description: 'description',
    status: 'status',
    version: 'version',
    approvalCount: 'approvalCount',
    submittedAt: 'submittedAt',
    approvedAt: 'approvedAt',
    approvedById: 'approvedById',
    createdById: 'createdById',
    customerSignerName: 'customerSignerName',
    customerSignaturePath: 'customerSignaturePath',
    customerSignedAt: 'customerSignedAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const WorkReportCodeCounterScalarFieldEnum = {
    tenantId: 'tenantId',
    year: 'year',
    lastProgressive: 'lastProgressive',
    updatedAt: 'updatedAt'
};
export const TechnicianCostRateScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    userId: 'userId',
    hourlyCost: 'hourlyCost',
    validFrom: 'validFrom',
    createdAt: 'createdAt',
    createdById: 'createdById'
};
export const WorkReportSessionScalarFieldEnum = {
    id: 'id',
    workReportId: 'workReportId',
    sortOrder: 'sortOrder',
    technicianId: 'technicianId',
    tariffId: 'tariffId',
    timeMode: 'timeMode',
    startTime: 'startTime',
    endTime: 'endTime',
    breakMinutes: 'breakMinutes',
    effectiveMinutes: 'effectiveMinutes',
    billableMinutes: 'billableMinutes',
    tariffSnapshot: 'tariffSnapshot',
    costSnapshot: 'costSnapshot'
};
export const WorkReportActivityScalarFieldEnum = {
    id: 'id',
    sessionId: 'sessionId',
    sortOrder: 'sortOrder',
    description: 'description',
    minutes: 'minutes',
    treatment: 'treatment',
    machineId: 'machineId'
};
export const WorkReportLineScalarFieldEnum = {
    id: 'id',
    workReportId: 'workReportId',
    sortOrder: 'sortOrder',
    kind: 'kind',
    productId: 'productId',
    description: 'description',
    quantity: 'quantity',
    unitPrice: 'unitPrice',
    vatRateId: 'vatRateId',
    treatment: 'treatment',
    stockDocumentId: 'stockDocumentId',
    contractLineId: 'contractLineId',
    licenseEffectiveDate: 'licenseEffectiveDate',
    licenseChangeId: 'licenseChangeId',
    machineId: 'machineId'
};
export const WorkReportPublicationScalarFieldEnum = {
    id: 'id',
    workReportId: 'workReportId',
    version: 'version',
    pdfPath: 'pdfPath',
    sha256: 'sha256',
    sizeBytes: 'sizeBytes',
    sections: 'sections',
    createdAt: 'createdAt',
    publishedAt: 'publishedAt',
    publishedById: 'publishedById',
    revokedAt: 'revokedAt',
    revokedById: 'revokedById',
    supersededAt: 'supersededAt'
};
export const WorkReportShareLinkScalarFieldEnum = {
    id: 'id',
    workReportId: 'workReportId',
    tokenHash: 'tokenHash',
    recipientEmail: 'recipientEmail',
    version: 'version',
    createdById: 'createdById',
    createdAt: 'createdAt',
    expiresAt: 'expiresAt',
    revokedAt: 'revokedAt',
    revokedById: 'revokedById',
    revokeReason: 'revokeReason',
    lastOpenedAt: 'lastOpenedAt',
    openCount: 'openCount',
    downloadCount: 'downloadCount'
};
export const WorkReportEventScalarFieldEnum = {
    id: 'id',
    tenantId: 'tenantId',
    workReportId: 'workReportId',
    type: 'type',
    version: 'version',
    payload: 'payload',
    actorUserId: 'actorUserId',
    createdAt: 'createdAt'
};
export const WorkReportTravelSettingsScalarFieldEnum = {
    tenantId: 'tenantId',
    origin: 'origin',
    defaultVehicleId: 'defaultVehicleId',
    vehicles: 'vehicles',
    updatedAt: 'updatedAt'
};
export const SortOrder = {
    asc: 'asc',
    desc: 'desc'
};
export const NullableJsonNullValueInput = {
    DbNull: DbNull,
    JsonNull: JsonNull
};
export const JsonNullValueInput = {
    JsonNull: JsonNull
};
export const QueryMode = {
    default: 'default',
    insensitive: 'insensitive'
};
export const NullsOrder = {
    first: 'first',
    last: 'last'
};
export const JsonNullValueFilter = {
    DbNull: DbNull,
    JsonNull: JsonNull,
    AnyNull: AnyNull
};
//# sourceMappingURL=prismaNamespaceBrowser.js.map